// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Inter-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Inter-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/Inter-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/Inter-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/Inter-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/Inter-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./fonts/Inter-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./fonts/Inter-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./images/likegrey.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./images/likegreen.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./images/dislikegrey.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./images/dislikered.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./images/close.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./images/arrowbottom.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Abel);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "interregular";
  font-style: normal;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "intermedium";
  font-style: normal;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "intersemibold";
  font-style: normal;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
  font-family: "interbold";
  font-style: normal;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: "interextrabold";
  font-style: normal;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}
@font-face {
  font-family: "interlight";
  font-style: normal;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
@font-face {
  font-family: "interthin";
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
}
@font-face {
  font-family: "interextralight";
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
:root {
  --widgetIconpostion: flex-start;
  --widgetBorderRadius: 25px;
  --widgetIconShape: 24px;
  --widgetHeaderBG: #5b55ff;
  --widgetChatMessageColor: #e3e4e5;
  --widgetChatCustomerMessageColor: #e2e2fa;
  --widgetActionMessageColor: #fa6e8f;
  --widgetPreviewFont: "interregular";
  --widgetStatusColor: "#5B55FF";
  --widgetStatusBorderColor: "#5B55FF";
  --widgetagentStatusTableColor: "#575CFF";
  --widgetdispositionLinkColor: "#575CFF";
  --widgetDeleteDispositionStatus: "#5B55FF";
}

body {
  font-size: 14px;
  overflow: hidden;
  line-height: 24px;
  font-family: "interregular";
}

.chatPreview {
  position: fixed;
  bottom: 0px;
  cursor: pointer;
}
.chatPreview.chatright {
  right: 0px;
  display: flex;
  align-items: flex-end;
  gap: 20px;
  animation: cssAnimation 0s 4s forwards;
  visibility: hidden;
}

@keyframes cssAnimation {
  to {
    visibility: visible;
  }
}
.chatIcon {
  background: var(--widgetIconBg);
  border-radius: var(--widgetIconShape);
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-width: 40px;
  min-height: 40px;
  transition: 8s opacity ease;
}
.chatIcon svg {
  margin: 0 6px;
}
.chatIcon p {
  margin: 0 10px 0 0;
  font-size: 14px;
  color: #fff;
}
.chatIcon.chatIconclose {
  bottom: 0px;
  right: 0px;
  position: fixed;
  cursor: pointer;
  animation: fadeIn 2s ease-in both;
}
@media (max-width: 767px) {
  .chatIcon.chatIconclose {
    right: 10px;
  }
}
.chatIcon.chatIconclose.chatIconPositionLeft {
  left: 0px;
}

.primarybtn {
  background-color: #00b885;
  border: 1px solid #00b885;
  color: #ffffff;
  padding: 9px 18px;
  width: 100%;
  height: 38px;
  font-family: "intersemibold";
  text-align: center;
  font-size: 14px;
  box-shadow: none;
  line-height: normal;
}
.primarybtn:hover {
  background-color: #00b885 !important;
  border: 1px solid #00b885 !important;
  color: #ffffff !important;
}
.primarybtn.startbtn {
  background-color: var(--dynamicprimaryButtonBg);
  border: 1px solid var(--dynamicprimaryButtonBg);
}
.primarybtn.startbtn:hover {
  background-color: var(--dynamicprimaryButtonBg) !important;
  border: 1px solid var(--dynamicprimaryButtonBg) !important;
  color: #ffffff !important;
}
.primarybtn span {
  text-overflow: ellipsis;
  max-width: 250px;
  white-space: normal;
  overflow: hidden;
}
.primarybtn:hover {
  background-color: var(--primaryButtonBg);
  border: var(--primaryButtonBg);
  color: var(--dynamicButtonText);
}
.primarybtn:focus {
  background-color: var(--primaryButtonBg);
  border: var(--primaryButtonBg);
  color: var(--dynamicButtonText);
}
.primarybtn.primaryhiddenbtn {
  background-color: #f5f6f7;
  border: 1px solid #f5f6f7;
  color: #aaabad;
}
.primarybtn.primaryhiddenbtn:hover {
  background-color: #f5f6f7 !important;
  border: 1px solid #f5f6f7 !important;
  color: #aaabad !important;
}
.primarybtn.primarybtnLeft {
  max-width: 200px;
  margin: 0 auto 0 0;
  width: auto;
}
.primarybtn.primarybtnCenter {
  max-width: 200px;
  margin: 0 auto;
  text-align: center;
  width: auto;
  display: block;
}
.primarybtn.primarybtnRight {
  max-width: 200px;
  margin: 0 0 0 auto;
  width: auto;
}
.primarybtn.primarylabel {
  border: 1px solid #DCF5EE;
  border-radius: 12px;
  padding: 2px 8px;
  color: #252526;
  width: auto;
  height: auto;
  font-size: 10px;
  background: #DCF5EE;
  font-family: "intermedium";
  letter-spacing: 0.2px;
}
.primarybtn.primaryhiddenbtn {
  background-color: #f5f6f7;
  border: 1px solid #f5f6f7;
  color: #aaabad;
}
.primarybtn.primaryhiddenbtn:hover {
  background-color: #f5f6f7 !important;
  border: 1px solid #f5f6f7 !important;
  color: #aaabad !important;
}

/* Apply the animation to the chatbot element */
.animatechatbot {
  animation: slideIn 0.5s ease-in-out forwards;
  /* Animation properties */
  /* Other styles for the chatbot element */
  width: 200px;
  height: 200px;
  background-color: #ccc;
}

@keyframes slide-in-up {
  0% {
    opacity: 0;
    transform: translate(180px, 250px) scale(0);
  }
  100% {
    transform: translate(0px, 0px) scale(1);
    opacity: 1;
  }
}
@keyframes slide-in-up {
  0% {
    opacity: 0;
    transform: translate(5px, 250px) scale(0);
  }
  100% {
    transform: translate(0px, 0px) scale(1);
    opacity: 1;
  }
}
@keyframes worktualChatfadeInUp {
  from {
    opacity: 0;
    /* Start opacity */
    transform: translateY(20px);
    /* Start position */
  }
  to {
    opacity: 1;
    /* End opacity */
    transform: translateY(0);
    /* End position */
  }
}
.chatbotlayout.worktualChatvisible {
  visibility: visible;
  /* -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both; */
  opacity: 0;
  /* Start with opacity 0 */
  animation: worktualChatfadeInUp 0.4s forwards ease-in-out;
  transition: filter 0.3s ease;
  /* Animation properties */
}

.chatbotlayout.worktualmobilevisible {
  visibility: visible;
  /* -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both; */
  /* Start with opacity 0 */
  /* Animation properties */
  border-radius: 0 !important;
}

.chatbotlayout {
  width: 365px;
  visibility: hidden;
  margin: 0;
  position: fixed;
  bottom: 0;
  border-radius: var(--widgetBorderRadius);
  right: 0px;
  z-index: 99;
  transition: filter 0.3s ease;
  overflow: hidden;
}
.chatbotlayout .chatIcon {
  border-radius: var(--widgetIconShape);
  width: 48px;
  height: 48px;
  position: absolute;
  bottom: -85px;
  cursor: pointer;
  display: inline;
  right: 0;
}
.chatbotlayout .chatHeader {
  display: flex;
  padding: 14px 22px;
  gap: 16px;
  background: var(--widgetHeaderBG);
  border-top-left-radius: var(--widgetBorderRadius);
  border-top-right-radius: var(--widgetBorderRadius);
  justify-content: space-between;
  align-items: center;
}
.chatbotlayout .chatHeader ul {
  padding: 0;
  list-style: none;
  color: #ffffff;
  margin: 0;
  width: calc(100% - 100px);
}
.chatbotlayout .chatHeader ul li {
  color: var(--dynamictextHeader);
}
.chatbotlayout .chatHeader ul li h2 {
  margin: 0;
  font-size: 16px;
  font-family: "intersemibold";
  line-height: 22px;
}
.chatbotlayout .chatHeader ul li h2:first-letter {
  text-transform: capitalize;
}
.chatbotlayout .chatHeader ul li p {
  margin: 2px 0 0;
  font-size: 12px;
  line-height: normal;
}
.chatbotlayout .chatHeader ul li p:first-letter {
  text-transform: capitalize;
}
.chatbotlayout .chatHeader .headerimg {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.7098039216);
  max-width: 42px;
  max-height: 42px;
  min-height: 42px;
  min-width: 42px;
}
.chatbotlayout .chatHeader .headerimg img {
  width: 100%;
  height: auto;
  object-fit: initial;
  max-width: 100%;
}
.chatbotlayout .chatHeader .rightcls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  position: relative;
  left: 10px;
}
.chatbotlayout .chatHeader .rightcls svg {
  cursor: pointer;
  fill: var(--dynamictextHeader);
}
.chatbotlayout .chatHeader .rightcls svg:nth-child(1) {
  padding: 0 0px;
  min-height: 18px;
  margin: 0 4px 0 0;
}
.chatbotlayout .chatHeader .rightcls svg:nth-child(2) {
  padding: 2px 0;
  min-width: 24px;
  height: 16px;
}
.chatbotlayout .chatbtm {
  padding: 8px 0;
  text-align: center;
  color: #aaabad;
  font-size: 10px;
}
.chatbotlayout.chatbotLayoutRight {
  transition: filter 0.3s ease;
  left: 0;
  right: unset;
}

.chatinfo {
  background-image: var(--backgroundImage);
  background-color: #fff;
  border-radius: 0px 0px var(--widgetBorderRadius) var(--widgetBorderRadius);
  border: 1px solid #e3e4e5;
}
.chatinfo .chatbottomview {
  display: flex;
  align-items: end;
  height: calc(100vh - 200px);
  overflow: hidden;
  padding: 16px 0 0;
  max-height: 500px;
  transition: 0.3s ease;
}
.chatinfo .chatbottomview.withnofooter {
  max-height: 568px;
  padding: 0;
}
@media (max-height: 700px) {
  .chatinfo .chatbottomview.withnofooter {
    height: calc(100vh - 132px);
  }
}
.chatinfo .welcomeMessage {
  text-align: left;
  flex: auto;
  padding: 16px;
}
.chatinfo .welcomeMessage h5 {
  color: #00B885;
  font-size: 20px;
  font-family: "interbold";
  margin-bottom: 10px;
}
.chatinfo .welcomeMessage .welcomeList {
  padding-inline-start: 0px;
  list-style: none;
}
.chatinfo .welcomeMessage .welcomeList li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #E3E4E5;
  margin-bottom: 8px;
  border-radius: 6px;
  padding: 8px 12px;
  cursor: pointer;
}
.chatinfo .welcomeMessage .welcomeList li h5 {
  font-size: 14px;
  color: #161717;
  margin: 0px;
  font-family: "intersemibold";
}
.chatinfo .chatMessage {
  display: flex;
  align-items: end;
  padding: 16px 12px 0 12px;
  overflow-y: auto;
  width: 100%;
  max-width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
  flex-direction: column-reverse;
  align-items: normal;
  height: 100%;
  overflow: hidden;
  overflow-y: scroll;
  scrollbar-color: #bbbbbb #f5f5f5;
  scrollbar-width: thin;
}
.chatinfo .chatMessage .chatleftview {
  width: 100%;
  margin: 16px 0 8px;
}
.chatinfo .chatMessage .chatleftview ul.profilerounds {
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0px;
}
.chatinfo .chatMessage .chatleftview ul.profilerounds .left {
  display: flex;
  gap: 8px;
  width: 100%;
}
.chatinfo .chatMessage .chatleftview ul.profilerounds .left li.lifirsts {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;
  min-width: 32px;
  min-height: 32px;
}
.chatinfo .chatMessage .chatleftview ul.profilerounds .left li img {
  object-fit: fill;
  height: 100%;
}
.chatinfo .chatMessage .chatleftview ul.profilerounds .left li .leftagentchat {
  background: var(--widgetChatMessageColor);
  border-radius: 12px;
  padding: 8px 10px;
  margin: 2px 0 0;
  line-height: 21px;
  word-break: break-word;
  position: relative;
  letter-spacing: -0.2px;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 78%;
}
.chatinfo .chatMessage .chatleftview ul.profilerounds .left li .leftagentchat p {
  margin: 0;
  font-family: "interregular";
  font-size: 14px;
  color: var(--dynamicAgentMessageTextColor);
  word-break: break-word;
}
.chatinfo .chatMessage .chatleftview ul.profilerounds .left li .leftagentchat p::first-letter {
  text-transform: capitalize;
}
.chatinfo .chatMessage .chatleftview ul.profilerounds .left li .leftagentchat a {
  text-decoration: underline;
  color: var(--dynamicAgentMessageTextColor);
}
.chatinfo .chatMessage .chatleftview ul.profilerounds .left li .leftagentchat.worktualcouponmain .worktualcoupons {
  padding: 8px;
  border-radius: 10px;
  border: 1px dashed var(--border-line, #D2D3D4);
  background: var(--Color-Black-White, #FFF);
  display: flex;
  align-items: center;
  margin: 8px 0 0;
}
.chatinfo .chatMessage .chatleftview ul.profilerounds .left li .leftagentchat.worktualcouponmain .worktualcoupons p {
  width: calc(100% - 22px);
  text-align: center;
  font-size: 14px;
  font-family: "intersemibold";
  text-transform: uppercase;
  white-space: nowrap;
  padding: 0 12px;
}
.chatinfo .chatMessage .chatleftview ul.profilerounds .left li:nth-child(2) {
  width: 100%;
}
.chatinfo .chatMessage .chatrightview {
  margin: 16px 0 8px;
}
.chatinfo .chatMessage .chatrightview ul {
  list-style: none;
  margin: 0;
  padding: 0 !important;
}
.chatinfo .chatMessage .chatrightview ul .right li p {
  background: var(--widgetChatCustomerMessageColor);
  border-radius: 6px;
  padding: 12px 12px 6px;
  margin: 0 0 10px 0;
  display: flex;
  font-family: "interregular";
  font-size: 12px;
  color: #ffffff;
  overflow-wrap: anywhere;
  gap: 8px;
}
.chatinfo .chatMessage .chatrightview ul .right .pdfimg a {
  display: flex;
  gap: 8px;
}
.chatinfo .chatMessage .chatrightview ul .right .pdfimg img {
  width: 32px;
}
.chatinfo .chatMessage .chatrightview ul .right .imageInner {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--widgetChatCustomerMessageColor);
  border-radius: 6px;
  padding: 6px 12px;
}
.chatinfo .chatMessage .chatrightview ul .right .imageInner img {
  width: 160px;
  border-radius: 8px;
}
.chatinfo .chatMessage .chatrightview .rightChat {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.chatinfo .chatMessage .chatrightview .rightChat .fileTitle {
  font-family: "interregular";
  color: var(--dynamicCustomerMessageTextColor);
  font-size: 14px;
  line-height: 21px;
  letter-spacing: -0.2px;
  background: var(--widgetChatCustomerMessageColor);
  border-radius: 12px;
  padding: 8px 10px;
  display: flex;
  word-break: break-word;
}
.chatinfo .chatMessage .chatrightview .rightChat .fileTitle::first-line {
  text-transform: capitalize;
}
.chatinfo .chatMessage .chatrightview .rightChat .fileTitle a {
  text-decoration: underline;
  color: var(--dynamicCustomerMessageTextColor);
}
.chatinfo .sendmail {
  display: flex;
  line-height: 10px;
  margin: 0 12px 0 0;
}
.chatinfo .sendmail span {
  color: var(--dynamicCustomerMessageTextColor);
  font-size: 10px;
}
.chatinfo .sendmail span:nth-child(2) {
  margin: 0 -3px;
  font-size: 18px;
}
.chatinfo .sendmailagent {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  line-height: 10px;
  white-space: nowrap;
  position: relative;
  right: -2px;
  top: 4px;
  margin-left: 2px;
}
.chatinfo .sendmailagent span {
  color: var(--dynamicAgentMessageTextColor);
  font-size: 10px;
}
.chatinfo .sendmailagent span:nth-child(2) {
  margin: 0 -3px;
  font-size: 18px;
}

.fileTitle {
  max-width: 72%;
  display: block;
}

.rightChat .rightChat .fileTitle {
  padding: 0 !important;
  max-width: 100% !important;
}

.agentconnect {
  text-align: center;
  color: #161717;
  font-size: 12px;
  margin: 0 1px;
  width: 92%;
  line-height: 18px;
  border-radius: 6px;
  background: #F8F9F9;
  font-family: "interregular";
  display: block;
  padding: 12px;
}
.agentconnect a {
  color: #161717;
}

.chatconnecter {
  font-family: "intersemibold";
  text-align: center;
  color: #656a6a;
  font-size: 12px;
  bottom: 130px;
  margin: 7px;
  width: 100%;
  background-color: #f5f6f7;
}
.chatconnecter span {
  font-family: "interregular";
}

.chatmessagefooter {
  margin-top: 0;
  position: relative;
}
.chatmessagefooter textarea {
  max-height: 60px !important;
  /* Track */
  /* Handle */
  /* Handle on hover */
}
.chatmessagefooter textarea:hover {
  border-color: #00B885;
}
.chatmessagefooter textarea::-webkit-scrollbar {
  width: 4px;
  border-radius: 3px;
}
.chatmessagefooter textarea::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 3px;
}
.chatmessagefooter textarea::-webkit-scrollbar-thumb {
  background: #d3d6de;
  border-radius: 3px;
}
.chatmessagefooter textarea::-webkit-scrollbar-thumb:hover {
  background: #d3d6de;
  border-radius: 3px;
}

.chatBody {
  background: #fff;
  padding: 0px;
  border-radius: 0px 0px var(--widgetBorderRadius) var(--widgetBorderRadius);
  border: 1px solid #e3e4e5;
}
.chatBody .chatbotformtitle {
  padding: 12px 16px 12px 24px;
  overflow: hidden;
  overflow-y: scroll;
  scrollbar-color: #bbbbbb #f5f5f5;
  scrollbar-width: thin;
  height: calc(100vh - 173px);
  max-height: 500px;
  margin: 0 0 14px;
}
.chatBody .chatbotformtitle h4 {
  margin: 0 0 6px;
  font-size: 14px;
  font-family: "intermedium";
}
.chatBody .chatbotformtitle p {
  line-height: 19px;
  color: #161717;
  margin: 0;
  font-size: 12px;
}
.chatBody .chatbotformtitle ul li {
  line-height: 19px;
  color: #161717;
  margin: 0;
  font-size: 12px;
}
.chatBody .chatbotformtitle.chatmsgform {
  overflow-y: hidden;
}
.chatBody .chatbotformtitle.chatreqsuccess {
  text-align: center;
  padding: 12px;
}
.chatBody .chatbotformtitle.chatreqsuccess .chatbotform {
  margin: 0;
}
.chatBody .chatbotformtitle.chatreqsuccess p {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 0;
}
.chatBody .chatbotformtitle.chatreqsuccess p span {
  font-family: "intermedium";
}
.chatBody .chatbotform {
  margin-top: 24px;
}
.chatBody .chatbotform .ant-form-item {
  margin: 0 0 10px 0;
}
.chatBody .chatbotform .formInputHeight {
  font-size: 14px;
  height: 38px;
  border-color: #D2D3D4;
  font-family: "interregular";
  border-radius: 6px;
}
.chatBody .chatbotform .formInputHeight:hover {
  border-color: var(--widgetActionMessageColor);
}
.chatBody .chatbotform .formInputHeight::placeholder {
  font-size: 14px;
  color: #828385;
  font-family: "interregular";
}
.chatBody .chatbotform .formtextareaHeight {
  font-family: "interregular";
  height: 80px;
  border-color: #D2D3D4;
  border-radius: 6px;
  box-shadow: 0px 2px 3px rgba(12, 21, 35, 0.04);
  padding: 6px 12px;
}
.chatBody .chatbotform .formtextareaHeight .ant-input {
  color: #00b885;
}
.chatBody .chatbotform .formtextareaHeight:hover {
  border-color: #00B885;
}
.chatBody .chatbotform .formtextareaHeight::placeholder {
  font-size: 14px;
  color: var(--widgetInputTextColor);
  font-family: "interregular";
}
.chatBody .chatbotform .formdropdown {
  margin-bottom: 12px;
  height: 40px;
}
.chatBody .chatbotform .formdropdown span.ant-select-arrow {
  margin-top: -1px !important;
}
.chatBody .chatbotform .formdropdown .ant-select-selector {
  font-size: 14px;
  height: 40px;
  font-family: "interregular";
  border-color: #bdbebf !important;
  width: 100%;
  padding: 0 5px;
  box-shadow: 0px 2px 3px rgba(12, 21, 35, 0.04);
  border-radius: 6px;
}
.chatBody .chatbotform .formdropdown .ant-select-selector:hover {
  border-color: #bdbebf;
  box-shadow: 0px 2px 3px rgba(12, 21, 35, 0.04);
}
.chatBody .chatbotform .formdropdown .ant-select-selector .ant-select-selection-item {
  padding: 5px;
}
.chatBody .chatbotform .formdropdown .ant-select-selector .ant-select-selection-placeholder {
  color: #828385;
  padding: 5px;
}
.chatBody .chatbotform .formdropdown.formdropdownsmall {
  width: 60px;
}
.chatBody .chatbotform .formdropdown.formdropdownsmall .ant-picker-suffix {
  display: none;
}
.chatBody .chatbotform .formdropdown.formdropdownsmall .ant-picker-suffix:hover {
  display: none;
}
.chatBody .chatbotform .formdropdown.formdropdownsmall .ant-picker-clear {
  display: none;
}
.chatBody .chatbotform .formdropdown.formdropdownsmall .ant-picker-input input {
  color: #828385;
}
.chatBody .chatbotform .formdropdown.formdropdownsmall .ant-picker-input input::placeholder {
  color: #828385;
}
.chatBody .chatbotform .formdropdown.formdropdownsmall .ant-select-selector {
  height: 32px;
  width: 46px;
}
.chatBody .chatbotform .formdropdown.formdropdownsmall .ant-select-selector .ant-select-selection-item {
  line-height: 20px;
  color: #828385;
}
.chatBody .chatbotform .formdropdown.formdropdownsmall .ant-select-selection-placeholder {
  line-height: 20px;
}
.chatBody .chatbotform .formdropdown.formdropdownsmall .ant-select-arrow {
  display: none;
}
.chatBody .chatbotform .formInputCalender {
  width: 100%;
  font-size: 14px;
  height: 38px;
  border-color: #bdbebf;
  font-family: "interregular";
  box-shadow: 0px 2px 3px rgba(12, 21, 35, 0.04);
  border-radius: 6px;
}
.chatBody .chatbotform .formInputCalender .ant-picker-input input::placeholder {
  font-size: 14px;
  color: #828385 !important;
  font-family: "interregular";
}
.chatBody .chatbotform .districtselection .ant-form-item-control-input-content label {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #F0F1F2;
  padding: 10px;
  color: #252526;
  font-family: "intermedium";
  font-size: 14px;
  line-height: 0;
}
.chatBody .chatbotform .districtselection .ant-form-item-control-input-content label:nth-child(1) {
  border-radius: 6px 6px 0 0;
}
.chatBody .chatbotform .districtselection .ant-form-item-control-input-content label:nth-last-child(1) {
  border-radius: 0 0 6px 6px;
}
.chatBody .chatbotform .addressselection .formaddress {
  margin: 0;
}
.chatBody .chatbotform .addressselection .formaddress label {
  display: block;
  color: #828385;
}

.chatviewLeft {
  text-align: left;
  padding: 0 20% 0 0;
}

.chatviewRight {
  text-align: right;
  padding: 0 20% 0 0;
}

.footercopyright {
  padding: 0px 8px 8px;
}
.footercopyright .footercopys {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin: 0 0 6px;
}
.footercopyright .footercopys img {
  cursor: pointer;
}
.footercopyright p {
  margin: 0;
  color: #757676;
  font-size: 10px;
  font-family: "interregular";
  line-height: 14px;
  text-align: center;
}

.chatFooter {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  min-height: 50px;
  border-radius: 0 0 12px 12px;
}
.chatFooter .chatFooterinput {
  background-color: #ffffff;
  margin: 5px 0;
  border-radius: 22px;
  padding: 6px 8px 6px 10px;
  display: flex;
  width: 100%;
  border: 1px solid #D2D3D4;
  align-items: center;
}
.chatFooter .chatFooterinput:hover {
  border: 1px solid #252526;
}
.chatFooter .chatFooterinput:focus-within {
  border: 1px solid #252526;
}
.chatFooter .attach {
  max-width: 30px;
  line-height: 5px;
  padding: 4px 5px 4px 4px;
  border-radius: 50px;
  margin-right: 6px;
  cursor: pointer;
}
.chatFooter .attach label {
  cursor: pointer;
}
.chatFooter .attach:hover {
  background-color: #EDEFF0;
}
.chatFooter .message {
  color: #828385;
  font-size: 13px;
  width: 90%;
  margin-right: auto;
}
.chatFooter .message label {
  position: relative;
  top: 2px;
}
.chatFooter .message .MessageInput {
  width: 100%;
  margin-bottom: 0;
  min-height: 32px !important;
  background: transparent;
  border: 1px solid transparent;
  box-shadow: none;
  font-family: "intermedium";
  color: #161717;
  font-size: 14px;
  padding-left: 8px;
  -webkit-text-size-adjust: 100%;
}
.chatFooter .message .MessageInput::placeholder {
  color: #828385;
}
.chatFooter .chaticons {
  color: #828385;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 6px;
  font-family: "interregular";
  border-radius: 50px;
  cursor: pointer;
}
.chatFooter .chaticons img {
  height: 23px;
}
.chatFooter .chaticons span {
  cursor: pointer;
  font-size: 20px;
  color: #828385;
  position: relative;
  margin-top: 0;
}
.chatFooter .chaticons:hover {
  background-color: #EDEFF0;
}
.chatFooter .emojipicker {
  position: absolute;
  bottom: 90px;
  left: 5px;
}

.invaliderror .ant-form-item-explain-error {
  font-size: 12px;
  margin: 4px 0 6px;
  font-family: "interregular";
  text-align: left;
  line-height: normal;
}
.invaliderror.invaliderroraddress {
  margin: 2px 0 10px;
}

.textpdf {
  width: 130px;
  border: 1px solid #e3e4e5;
  display: flex;
  align-items: center;
  padding: 5px 0;
  border-radius: 8px;
  justify-content: space-around;
  height: 24px;
  position: relative;
}
.textpdf .left {
  width: 30px;
}
.textpdf .left img {
  width: 24px;
  margin-top: 8px;
}
.textpdf .right p {
  font-size: 10px;
  line-height: 15px;
}
.textpdf .right p:nth-child(1) {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90px;
  white-space: nowrap;
  line-height: 12px;
  padding-top: 4px;
}
.textpdf p {
  margin: 0;
  padding: 0;
}

.imagesAttach {
  border-radius: 6px;
  position: relative;
  width: 44px;
  height: 44px;
}
.imagesAttach img {
  width: 42px;
  height: 42px;
  border: 1px solid #00e2a4;
  border-radius: 6px;
  object-fit: cover;
  margin: 0 0 0 6px;
}

.textpdfclose {
  position: absolute;
  top: -6px;
  right: -10px;
  width: 16px;
  height: 16px;
  background-color: #000000;
  border-radius: 50%;
  color: #ffffff;
  z-index: 9;
  text-align: center;
  line-height: 15px;
  cursor: pointer;
}

.chatBodymessageview {
  border-radius: 6px;
  width: 260px;
  margin: 24px 0 10px 3px;
}
.chatBodymessageview .chatbotformtitle {
  margin: 0;
  height: auto;
}
.chatBodymessageview .callbackreq {
  height: 200px;
}
.chatBodymessageview .chatbotformtitleWix {
  margin: 0;
  padding: 12px;
}
.chatBodymessageview .chatbotformtitleWix h4 {
  margin: 0 0 12px;
  font-size: 13px;
  font-family: "interregular";
  line-height: 20px;
}
.chatBodymessageview .chatbotformtitleWix .primarybtn.startbtn {
  background: #252526 !important;
  border-color: #252526 !important;
  margin: 0;
}
.chatBodymessageview .forminputcol {
  display: flex;
  align-items: center;
  gap: 10px;
}
.chatBodymessageview .forminputcol .ant-picker {
  box-shadow: none;
  background: #f7f9fc;
}
.chatBodymessageview .forminputcol .ant-picker:hover {
  border: 1px solid #bdbebf;
  background: #f7f9fc;
  box-shadow: none;
}
.chatBodymessageview .forminputcol .ant-picker.ant-picker-focused {
  background: #f7f9fc;
  border: 1px solid #bdbebf;
  box-shadow: none;
}
.chatBodymessageview .chatbotform {
  margin: 0;
}
.chatBodymessageview .chatbotform .ant-form-item {
  margin: 0 0 4px;
}

.icon_sendarrow:before {
  color: #00b885;
}

.icon_attach {
  color: #757676;
  font-size: 20px;
}

/* width */
.scrollerno::-webkit-scrollbar {
  width: 4px;
  border-radius: 3px;
}

.scroller::-webkit-scrollbar {
  width: 4px;
  border-radius: 3px;
}

/* Track */
.scroller::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 3px;
}

/* Handle */
.scroller::-webkit-scrollbar-thumb {
  background: #d3d6de;
  border-radius: 3px;
}

/* Handle on hover */
.scroller::-webkit-scrollbar-thumb:hover {
  background: #d3d6de;
  border-radius: 3px;
}

.leftmessage {
  max-width: 100%;
}

.messagedialogBtn {
  margin: 0 0 0 36px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  justify-content: flex-start;
}
.messagedialogBtn .dialogBtn {
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
  white-space: normal;
  background-color: #fff;
  font-family: var(--widgetPreviewFont);
  text-align: center;
  line-height: 16px;
  cursor: pointer;
  margin: 0;
  min-width: 80px;
  border: 1px solid #00b885;
  color: #00b885;
  display: inline-block;
  align-items: center;
  max-height: 60px;
  font-family: "interregular";
}
.messagedialogBtn .dialogBtn.red {
  border: 1px solid var(--widgetActionMessageColor);
  color: var(--widgetActionMessageColor);
}
.messagedialogBtn .dialogBtn.green {
  border: 1px solid var(--widgetActionMessageColor);
  color: var(--widgetActionMessageColor);
  background: var(--widgetActionMessageColorbg);
  font-family: "intermedium";
  text-transform: capitalize;
  font-size: 13px;
}
.messagedialogBtn:empty {
  display: none;
}

.addressBlock {
  border-radius: 12px;
  overflow: hidden;
  background: #E3E4E5;
  width: 244px;
  margin: 8px 0 16px 4px;
}
.addressBlock p {
  margin: 0;
  padding: 8px 10px;
}
.addressBlock .checkoutBtn {
  margin: 0;
}
.addressBlock .checkoutBtn label {
  border-top: 1px solid #fff;
  color: var(--widgetActionMessageColor);
  text-align: left;
  font-size: 14px;
  line-height: 19px;
  margin: 0;
  padding: 10px 7px;
  cursor: pointer;
  height: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: "intermedium";
  width: 94%;
}
.addressBlock .checkoutBtn input[type=radio] {
  margin: 0px !important;
}
.addressBlock h5 {
  border-top: 1px solid #fff;
  color: var(--widgetActionMessageColor);
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  margin: 0 -15px;
  padding: 10px 12px;
  cursor: pointer;
}

.addnewaddresses {
  border-top: 1px solid #fff;
  text-align: left;
  font-size: 14px;
  line-height: 19px;
  margin: 0;
  padding: 10px 7px;
  cursor: pointer;
  height: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: "intermedium";
  width: 94%;
}
.addnewaddresses input[type=radio] {
  margin: 0px !important;
}

.addressBlock div {
  width: 100%;
}

.addressBlock button {
  cursor: pointer;
}

.addressBlock label {
  height: 40px;
  align-items: center;
  width: 100%;
  border-top: 1px solid #fff;
  display: flex;
  align-items: center;
}

.welcomemessage {
  width: 100%;
  border-radius: 8px;
  background: #fff;
  display: flex;
  padding: 6px 12px;
  align-items: center;
  box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.15);
  position: relative;
  min-height: 36px;
  max-width: 177px;
  min-width: 50px;
  bottom: 2px;
}
.welcomemessage p {
  font-size: 12px;
  color: #000;
  font-family: "interregular";
  line-height: 16px;
  margin: 0;
  max-width: 170px;
}
.welcomemessage p:first-letter {
  text-transform: capitalize;
}
.welcomemessage img {
  width: 22px;
  height: 22px;
  position: absolute;
  left: -11px;
  top: -7px;
}
.welcomemessage::after {
  content: "";
  border-bottom: 12px solid rgba(219, 219, 219, 0.7215686275);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  position: absolute;
  right: -17px;
  transform: rotate(90deg);
  bottom: 16px;
  width: 3px;
}
.welcomemessage::before {
  content: "";
  border-bottom: 12px solid #ffffff;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  position: absolute;
  right: -15px;
  transform: rotate(90deg);
  z-index: 9;
  bottom: 16px;
  width: 2px;
}
.welcomemessage span {
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
  color: #828385;
  font-family: "ur_browser_app_rewamp";
  font-weight: 100;
}
.welcomemessage .welcomeimg {
  width: 36px;
  height: 36px;
  position: absolute;
  top: -20px;
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: #00b885;
  border-radius: 50%;
  padding: 4px;
  font-size: 14px;
  line-height: 20px;
}
.welcomemessage .welcomeimg img {
  border-radius: 50%;
  width: 100%;
}

.botMsgArea .topArea {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 4px 0;
  max-width: 84%;
}
.botMsgArea .topArea .botTitle {
  color: #252526;
  font-size: 14px;
  font-family: "intersemibold";
  margin: 0 12px 0 0;
}
.botMsgArea .topArea .botTitle::first-letter {
  text-transform: capitalize;
}
.botMsgArea .topArea .likebefore {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  width: 15px;
  height: 15px;
  display: inline-flex;
  margin-right: 2px;
  background-size: cover;
  cursor: pointer;
}
.botMsgArea .topArea .likeafter {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  width: 15px;
  height: 15px;
  display: inline-flex;
  margin-right: 2px;
  background-size: cover;
  cursor: pointer;
}
.botMsgArea .topArea .dislikebefore {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  width: 15px;
  height: 15px;
  display: inline-flex;
  background-size: cover;
  position: relative;
  top: 1px;
  cursor: pointer;
}
.botMsgArea .topArea .dislikeafter {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  width: 15px;
  height: 15px;
  display: inline-flex;
  background-size: cover;
  position: relative;
  top: 1px;
  cursor: pointer;
}

.paymentForm {
  padding: 10px;
  border-radius: 8px;
}
.paymentForm p {
  font-family: "interregular";
  color: #555658;
  font-size: 16px;
}
.paymentForm .inputArea {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin-bottom: 6px;
  font-family: "interregular";
  color: #505152;
  font-size: 14px;
}
.paymentForm .inputArea label {
  font-family: "interregular";
  color: #505152;
  font-size: 14px;
}
.paymentForm .inputArea input {
  height: 38px;
  border-radius: 6px;
}
.paymentForm .rowArea {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 12px;
}
.paymentForm .rowArea .smInput {
  width: 70px;
}
.paymentForm .rowArea .expiry {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 2px;
}
.paymentForm .rowArea .cvvInput {
  width: 100px;
}
.paymentForm .rowArea input {
  height: 38px;
  border-radius: 6px;
}
.paymentForm .rowArea label {
  font-family: "interregular";
  color: #505152;
  font-size: 14px;
  width: 100px;
}
.paymentForm .cardDetails {
  display: flex;
  align-items: center;
  font-family: "interregular";
  color: #555658;
  font-size: 14px;
  margin: 16px 0px;
  gap: 40px;
}

.formchat .btnSection {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 20px 0;
}
.formchat a {
  font-size: 12px;
}
.formchat .btnCancel {
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  line-height: 16px;
  cursor: pointer;
  min-width: 80px;
  max-width: 195px;
  font-family: "intersemibold";
  color: #252526;
  border: 1px solid #D2D3D4;
  background: #FFF;
}
.formchat .btnCancel:hover {
  outline: 1px solid;
}
.formchat .btnGreen {
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  background-color: #00b885;
  font-weight: 500;
  text-align: center;
  line-height: 16px;
  cursor: pointer;
  min-width: 80px;
  max-width: 195px;
  color: #fff;
  font-family: "intersemibold";
  border-color: #00b885;
}
.formchat .btnGreen:hover {
  background-color: #00E2A4;
}

.chatbottomview {
  position: relative;
}
.chatbottomview .conrfirmSection {
  position: absolute;
  border-radius: 12px;
  background: #fff;
  width: 75%;
  margin: 0px auto;
  top: 5%;
  padding: 16px;
  text-align: center;
  left: 26px;
  border: 1px solid #E3E4E5;
  box-shadow: 0px 19px 25px -13px rgba(0, 0, 0, 0.2509803922);
}
.chatbottomview .conrfirmSection p {
  color: #252526;
  font-size: 16px;
  font-family: "intersemibold";
  margin-top: 0px;
  margin-bottom: 10px;
  line-height: 20px;
}
.chatbottomview .conrfirmSection .btnSection .btnGreen {
  background: #252526 !important;
  border-color: #252526 !important;
}
.chatbottomview .btnCancel {
  border-radius: 6px;
  padding: 8px 4px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  line-height: 16px;
  cursor: pointer;
  margin: 5px;
  min-width: 80px;
  max-width: 195px;
  font-family: "intersemibold";
  color: #252526;
  border: 1px solid #D2D3D4;
  background: #FFF;
}
.chatbottomview .btnCancel:hover {
  outline: 1px solid;
}
.chatbottomview .btnGreen {
  border-radius: 6px;
  padding: 8px 4px;
  font-size: 14px;
  background-color: #00b885;
  font-weight: 500;
  text-align: center;
  line-height: 16px;
  cursor: pointer;
  margin: 5px;
  min-width: 80px;
  max-width: 195px;
  color: #fff;
  font-family: "intersemibold";
}
.chatbottomview .btnGreen:hover {
  background-color: #00E2A4;
}

.mandatory {
  color: #EB3F67;
}

.ant-modal.loginpagepopup {
  width: 964px !important;
}
.ant-modal.loginpagepopup .ant-modal-footer {
  display: none;
}
.ant-modal.loginpagepopup .ant-modal-header {
  display: none;
}
.ant-modal.loginpagepopup .ant-modal-body {
  padding: 0;
  background: #fff;
  float: left;
  border-radius: 10px;
}
.ant-modal.loginpagepopup .anticon-close {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  width: 22px;
  height: 22px;
}
.ant-modal.loginpagepopup .anticon-close svg {
  display: none;
}

.p-PaymentDetails-group {
  position: relative;
}

.chatbottomview button {
  border: 1px solid transparent;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  border-radius: 4px;
  color: #fff;
  background-color: #5cb85c;
  border-color: #4cae4c;
  margin-bottom: 0rem;
  margin-top: 0.5rem;
}

.paypalview {
  width: 100%;
  max-width: 100%;
  position: absolute;
  top: 10px;
  margin: 0;
  height: 350px;
  border: none;
}

.paymentscroll {
  overflow-y: overlay;
  height: calc(100vh - 0px);
  padding: 0 16px;
}

.braintree-option {
  border-color: #E3E4E5;
}

.braintree-placeholder {
  display: none;
}

.braintree-option .braintree-option__label {
  color: #828385;
  font-family: "interregular";
}

.braintree-option:hover .braintree-option__label {
  color: #828385;
  font-weight: 400;
  font-family: "interregular";
}

.braintree-sheet {
  border: 1px solid #E3E4E5;
  padding: 12px;
}

.braintree-sheet__header {
  border-bottom: 1px solid #E3E4E5;
}

.braintree-sheet__content--form .braintree-form__field-group .braintree-form__field .braintree-form__hosted-field {
  border: 1px solid #E3E4E5;
  border-radius: 6px;
}

.braintree-sheet__content--form .braintree-form__field-group .braintree-form__label {
  color: #828385;
  font-family: "interregular";
}

.braintreePayButton {
  width: 100%;
  border: 1px solid #00b885;
  background-color: #00b885;
  color: #ffffff;
  padding: 12px;
  margin: 30px auto 16px;
  height: 40px;
  line-height: 15px;
  font-size: 16px;
}
.braintreePayButton:hover {
  border: 1px solid #00b885;
  background-color: #00b885 !important;
}

.braintree-large-button {
  background: transparent;
  border-color: #000000;
}

.braintree-large-button:hover {
  font-size: 14px;
  font-weight: 400;
  background: transparent;
  border-color: #000000;
}

.braintree-form__notice-of-collection a {
  color: #575CFF;
  font-size: 14px;
  text-decoration: none;
  font-family: "interregular";
}

.braintree-sheet__content--form .braintree-form__field-group .braintree-form__field-error {
  font-family: "interregular";
  font-size: 12px;
}

.braintree-sheet--has-error .braintree-sheet__error .braintree-sheet__error-text {
  font-family: "interregular";
  font-size: 12px;
}

/*----------------- MAIN CONTAINER -----------------*/
/*SET NEW FONT*/
/*
@import 'https://fonts.googleapis.com/css?family=Poiret+One';
*/
/* to expand the width to full width or any other size. max-width: 100%;*/
#rxp-hpp {
  background: #ffffff;
  font-family: "Abel", sans-serif;
}

#another-card-section {
  background: #f9f9f9;
  padding-top: 20px;
}

#another-card-section .panel-title,
#saved-card-section .panel-title {
  color: #990033;
}

.panel-group .panel {
  border-radius: 0px;
}

/*----------------- HEADER -----------------*/
#rxp-header {
  margin-bottom: 0px;
}

#rxp-header-title {
  background: transparent;
  color: #990033;
  padding: 20px 30px 0px 0px;
  font-size: 1.5em;
}

/*----------------- FORM -----------------*/
.panel {
  border-color: #ffffff;
}

#rpx-another-card {
  margin-top: 30px;
}

#rpx-cardnum-section .form-group {
  display: flex;
  width: 100%;
}

/* This is to change the look and size of the labels */
#rpx-another-card .control-label {
  font-family: "Abel", sans-serif;
  margin-top: 15px;
}

/* This is to change the look and size of the input */
#rpx-another-card .form-control {
  border: 0px;
  height: 50px;
  background-color: #dddddd;
  font-family: "Abel", sans-serif;
  border-radius: 0px;
}

#rpx-another-card .has-error .form-control {
  background-color: #ffcccc;
}

.input-group-addon {
  background-color: #990033;
  border: 0px solid #9900cc;
  color: #ffffff;
}

/* the following are to allow the label on the left and the input on the right */
#rpx-cardnum-section {
  position: relative;
}

#rpx-cardnum-title {
  width: 50%;
}

#rpx-cardnum-item {
  position: absolute;
  top: -25px;
  right: 0px;
}

#rpx-expiry-date {
  margin-bottom: 10px;
}

#rpx-expiry-date .col-xs-5 {
  width: 20%;
}

#rpx-expiry-date .slash {
  width: 10%;
  margin-top: 10px;
}

#rpx-expiry-date,
#rpx-security-code {
  width: 100%;
}

#rpx-date-cccvc-section .form-group .col-xs-12,
#rpx-cardholder-section .form-group .col-xs-12 {
  width: 50%;
}

#rpx-cardnum-title,
#rpx-cardnum-item {
  width: 50%;
}

#rpx-cardnum-box {
  width: 50%;
}

/*----------------- DCC -----------------*/
.btn-dcc.active {
  border-bottom: 2px solid #990033;
}

.rxp-dcc-offer-legal {
  font-size: 0.7em;
}

.panel-dcc .panel-body .rxp-title {
  font-size: 1.2em;
  color: #990033;
}

.dcc-title-box {
  line-height: 1.1em;
}

/*----------------- CARD MANAGEMENT -----------------*/
#rpx-saved-card .control-label,
#rpx-another-card .control-label {
  font-family: "Abel", sans-serif;
}

#rpx-saved-card .panel-saved-card:hover {
  border-top: 1px solid #990033;
  border-bottom: 1px solid #990033;
}

/*----------------- BUTTON -----------------*/
/* this is the actual button */
#main-btn-box .btn-hpp-a {
  font-size: 1.25em;
  background-color: #990033;
  font-weight: 100;
  margin-bottom: 20px;
  box-shadow: 1px 2px 6px #cbcbcb;
}

/*----------------- FOOTER -----------------*/
/* this is for the entire footer */
#rxp-footer {
  display: none;
}

.cardpaybtn {
  width: 100%;
  margin: 10px 0 16px;
  border: none;
  border-radius: 6px;
  padding: 12px 12px;
  color: #ffffff;
  cursor: pointer;
}

.fc-frame {
  min-height: 73px;
  min-width: 65px;
  overflow: hidden;
  position: fixed;
  right: 15px;
  z-index: 2147483600;
}

.typing {
  position: relative;
  top: -20px;
  left: -8px;
}
.typing span {
  content: "";
  animation: blink 1.5s infinite;
  animation-fill-mode: both;
  height: 8px;
  width: 8px;
  background: #00b885;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 50%;
}
.typing span:nth-child(2) {
  animation-delay: 0.2s;
  margin-left: 12px;
}
.typing span:nth-child(3) {
  animation-delay: 0.4s;
  margin-left: 24px;
}

@keyframes blink {
  0% {
    opacity: 0.1;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.1;
  }
}
.lottie {
  position: relative;
  top: 0px;
}

.lottiebot {
  display: flex;
  align-items: center;
  background: transparent !important;
  padding: 0 !important;
  font-style: italic;
  text-transform: lowercase;
  margin: 0 !important;
  position: relative;
  top: -4px;
}
.lottiebot .sendmailagent {
  margin: 0 !important;
}

.endchats {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  height: 100%;
  border-radius: var(--widgetBorderRadius);
  background: rgba(0, 0, 0, 0.4509803922);
  z-index: 99;
}
.endchats .endchatsinner {
  background: #F0F1F2;
  bottom: 0;
  position: absolute;
  width: 100%;
  border-radius: 12px 12px var(--widgetBorderRadius) var(--widgetBorderRadius);
  padding: 0 0 8px;
}
.endchats h3 {
  color: #252526;
  font-size: 18px;
  font-family: "intersemibold";
  line-height: 25px;
  letter-spacing: -0.4px;
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
}
.endchats h3 svg {
  cursor: pointer;
}
.endchats .endchatslist {
  margin: 0 16px;
  background: #fff;
  border-radius: 12px;
}
.endchats .endchatslist p {
  border-bottom: 1px solid #D2D3D4;
  padding: 14px 16px 14px 0;
  color: #252526;
  font-family: "intermedium";
  font-size: 14px;
  line-height: 18px;
  display: flex;
  gap: 12px;
  align-items: center;
  margin: 0 0 0 16px;
  cursor: pointer;
}
.endchats .endchatslist p:nth-last-child(1) {
  border: none;
}
.endchats .endchatslist p svg {
  height: 14px;
}
.endchats .endlanguages {
  background: #fff;
  box-shadow: 0px 6px 8px 0px rgba(12, 21, 35, 0.18);
  width: calc(100% - 1px);
  left: 0.4px;
  bottom: 0.4px;
  overflow: hidden;
}
.endchats .endchatli ul {
  margin: 0;
  padding: 0;
}
.endchats .endchatli ul li {
  color: #252526;
  font-family: "intermedium";
  font-size: 14px;
  line-height: 18px;
  padding: 12px 16px;
  cursor: pointer;
}
.endchats .endchatli ul li:hover {
  background: #DCF5EE;
}
.endchats .enchatsinputmain {
  margin: 0 16px;
}
.endchats .enchatsinputmain input {
  border-radius: 10px;
  border: 1px solid #D2D3D4;
  background: #FFF;
  box-shadow: 0px 2px 3px 0px rgba(12, 21, 35, 0.04);
  display: flex;
  width: auto;
  height: 48px;
  padding: 0 12px;
  align-items: center;
  color: #828385;
  font-family: "intermedium";
  font-size: 16px;
  line-height: 18px;
  width: 92%;
}
.endchats .endchatsbtn {
  border-radius: 6px;
  background: #DE003D;
  color: #fff;
  text-align: center;
  font-family: "intersemibold";
  font-size: 14px;
  max-height: 38px;
  display: flex;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
  margin: 16px;
  cursor: pointer;
}
.endchats .endchatsbtn.endchatsgreen {
  background: #00B885;
}

.worktualmobileBrowser {
  /*   .chatPreview {
    display: none;
  } */
}
.worktualmobileBrowser .chatbotlayout {
  width: 100%;
  height: 100vh;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
}
.worktualmobileBrowser .chatPreviewMobileHide {
  visibility: hidden;
}
.worktualmobileBrowser .chatPreviewMobileVisible {
  visibility: visible;
}
.worktualmobileBrowser .chatbottomview {
  height: calc(100vh - 192px);
  max-height: 100vh;
}
.worktualmobileBrowser .endchatsinner {
  border-radius: 12px 12px 0 0;
}
.worktualmobileBrowser .chatinfo {
  border-radius: 0;
}
.worktualmobileBrowser .chatHeader {
  border-radius: 0;
}
.worktualmobileBrowser .chatbotformtitle {
  height: calc(100vh - 128px);
  max-height: 100vh;
}
.worktualmobileBrowser .chatBody {
  border-radius: 0;
}

.ant-checkbox-group {
  display: grid;
  align-items: center;
  gap: 2px;
}

.groupchattitle {
  color: #252526 !important;
  font-size: 14px !important;
  line-height: normal !important;
  background: transparent !important;
  font-family: "intermedium";
  padding: 10px 0 !important;
  display: block !important;
}

textarea#Sdfgsdgsdgsd::placeholder {
  color: #828385;
}

.ant-form-item-explain {
  padding-top: 2px;
}

.ant-radio.ant-radio-checked .ant-radio-inner {
  border-color: #fff;
}
.ant-radio.ant-radio-checked .ant-radio-inner:after {
  background-color: var(--dynamicprimaryButtonBg);
  width: 28px;
  height: 28px;
  margin-top: -14px;
  margin-left: -14px;
}

.ant-radio-wrapper:hover :where(.css-dev-only-do-not-override-6j9yrn).ant-radio-wrapper,
:where(.css-dev-only-do-not-override-6j9yrn).ant-radio-wrapper:hover .ant-radio-inner,
:where(.css-dev-only-do-not-override-6j9yrn).ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner,
:where(.css-dev-only-do-not-override-6j9yrn).ant-checkbox:not(.ant-checkbox-disabled):hover .ant-checkbox-inner {
  border-color: var(--dynamicprimaryButtonBg) !important;
}

:where(.css-dev-only-do-not-override-6j9yrn).ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
  background: var(--dynamicprimaryButtonBg) !important;
}

.ant-radio.ant-radio-checked .ant-radio-inner {
  background-color: #fff;
}

.ant-checkbox .ant-checkbox-inner {
  height: 18px;
  width: 18px;
}

span.ant-radio span.ant-radio-inner {
  height: 18px;
  width: 18px;
}
span.ant-radio span.ant-radio-inner:hover {
  border-color: #00b885;
}

.ant-checkbox.ant-checkbox-checked .ant-checkbox-inner {
  background-color: var(--dynamicprimaryButtonBg);
  border: 1px solid var(--dynamicprimaryButtonBg);
  border-radius: 4px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.0784313725);
}

:where(.css-dev-only-do-not-override-2q8sxy).ant-input:focus,
:where(.css-dev-only-do-not-override-2q8sxy).ant-input:focus-within {
  box-shadow: none !important;
}

.emailinputs {
  display: grid !important;
  gap: 6px !important;
}
.emailinputs span {
  font-size: 12px;
  color: #DE003D;
}

.chatmsgbox {
  width: 100%;
  display: flex;
  gap: 10px;
  align-items: center;
}

.chatleftview .sendmailagent {
  display: none;
}
.chatleftview:hover .sendmailagent {
  display: block;
}

.chatrightview .sendmail {
  display: none;
}
.chatrightview:hover .sendmail {
  display: block;
}

.radiobtn {
  width: 100%;
}
.radiobtn .radioblock {
  display: grid;
  align-items: center;
  gap: 2px;
}
.radiobtn .radioblock label {
  background: #F0F1F2;
  padding: 10px;
  color: #252526;
  font-family: "intermedium";
  font-size: 14px;
  line-height: 0;
  display: flex;
  align-items: center;
}
.radiobtn .radioblock label:nth-child(1) {
  border-radius: 6px 6px 0 0;
}
.radiobtn .radioblock label:nth-last-child(1) {
  border-radius: 0 0 6px 6px;
}

@keyframes fadeInIcon {
  99% {
    visibility: hidden;
  }
  100% {
    visibility: visible;
  }
}
.worktualcalendar {
  border-top: 1px solid #D2D3D4;
  border-bottom: 1px solid #D2D3D4;
  margin: 12px 0;
  padding: 12px 0;
}
.worktualcalendar .worktualcalendartop {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 0 0 12px;
}
.worktualcalendar .worktualcalendartop p {
  font-family: "intermedium" !important;
  line-height: normal;
  display: flex;
  align-items: center;
  gap: 6px;
}
.worktualcalendar .worktualcalendarweeks {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 6px;
}
.worktualcalendar .worktualcalendarweeks p {
  width: 10%;
  border-radius: 6px;
  min-width: 24px;
  min-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "intermedium" !important;
  margin: 4px 0 !important;
  border: 1px solid var(--widgetChatMessageColor);
  cursor: pointer !important;
}
.worktualcalendar .worktualcalendarweeks p:hover {
  border: 1px solid var(--dynamicAgentMessageTextColor);
}
.worktualcalendar .worktualcalendarweeks.worktualsu p {
  font-family: "interlight" !important;
  pointer-events: none;
}

p.worktualbtns {
  color: var(--widgetActionMessageColor) !important;
  font-family: "intersemibold" !important;
  text-align: center;
  margin: 0 auto 4px !important;
  display: table;
  cursor: pointer;
}

p.worktualdisable {
  opacity: 0.3;
}
p.worktualdisable:hover {
  border-color: transparent !important;
}

.worktualmonths {
  display: flex;
  flex-wrap: wrap;
  margin: 12px 0;
}
.worktualmonths p {
  width: 33%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "intermedium" !important;
  margin: 8px 0 !important;
  opacity: 0.5;
  cursor: pointer;
}
.worktualmonths p.active {
  opacity: 1;
}

.worktualtimer {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  background: var(--widgetChatMessageColor);
  padding: 24px 16px;
  border-top: 0.1px solid var(--dynamicAgentMessageTextColor);
  margin: 12px 0;
  border-bottom: 0.1px solid var(--dynamicAgentMessageTextColor);
  border-radius: 0;
}
.worktualtimer svg {
  width: 24px;
  cursor: pointer;
}
.worktualtimer .worktualtimerinner {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: center;
}
.worktualtimer .worktualtimerinner p {
  width: 42%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "intermedium" !important;
  border: 0.2px solid var(--dynamicAgentMessageTextColor);
  border-radius: 6px;
  cursor: pointer;
  padding: 4px;
  margin: 0;
}
.worktualtimer .worktualtimerinner p:hover {
  background: var(--widgetChatCustomerMessageColor);
}
.worktualtimer .worktualtimerinner p.activewk {
  background: var(--widgetChatCustomerMessageColor);
}

.ant-picker-cell-inner.ant-picker-calendar-date {
  padding: 0 !important;
  height: 24px !important;
}

.ant-radio-group.ant-radio-group-outline.ant-picker-calendar-mode-switch {
  display: none;
}

.ant-picker-calendar-header {
  justify-content: center !important;
  align-items: center;
  padding: 0 0 6px !important;
}

.ant-select-selector {
  background: transparent !important;
  border: 0 !important;
}

span.ant-select-arrow {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat;
  background-size: 10px;
  background-position: center;
  width: 16px;
  right: 6px !important;
  height: 16px !important;
  margin: -7px 0 0 !important;
}
span.ant-select-arrow span {
  display: none;
}

table.ant-picker-content th {
  font-family: "interlight" !important;
  font-size: 14px !important;
  color: var(--dynamicAgentMessageTextColor) !important;
  height: 24px !important;
  width: 24px !important;
  padding: 0 0 10px !important;
  text-align: center;
}
table.ant-picker-content td {
  font-family: "intermedium" !important;
  font-size: 14px !important;
  color: var(--dynamicAgentMessageTextColor) !important;
}

.ant-picker-calendar-date-value {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ant-picker-cell-inner.ant-picker-calendar-date {
  border: 0 !important;
  margin: 4px auto !important;
  border-radius: 6px !important;
  height: 24px !important;
  width: 24px !important;
}

span.ant-select-selection-item {
  color: var(--dynamicAgentMessageTextColor) !important;
  font-family: "intermedium" !important;
}

.ant-select-focused:where(.css-dev-only-do-not-override-2q8sxy).ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {
  box-shadow: none !important;
}

.rc-virtual-list-scrollbar.rc-virtual-list-scrollbar-vertical {
  width: 3px !important;
}

.ant-picker-calendar.ant-picker-calendar-full,
.ant-picker-panel {
  background: var(--widgetChatMessageColor) !important;
}

.worktualmaincalendar {
  border-radius: 12px;
  background: var(--widgetChatMessageColor);
  padding: 12px 0;
}
.worktualmaincalendar p {
  margin: 0;
  padding: 0 16px;
}

.ant-picker-calendar.ant-picker-calendar-full {
  border-top: 0.1px solid var(--dynamicAgentMessageTextColor);
  padding: 12px 16px;
  margin: 12px 0;
  border-bottom: 0.1px solid var(--dynamicAgentMessageTextColor);
}

td.ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner.ant-picker-calendar-date {
  background: var(--widgetChatCustomerMessageColor) !important;
}
td.ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner.ant-picker-calendar-date .ant-picker-calendar-date-value {
  color: var(--dynamictextHeader) !important;
  outline: 1px solid var(--dynamicAgentMessageTextColor) !important;
  border-radius: 6px;
}

:where(.css-dev-only-do-not-override-2q8sxy).ant-select-dropdown {
  box-shadow: 0px 2px 3px 0px rgba(12, 21, 35, 0.23);
  background: #fff;
  padding: 4px 0;
}

.ant-select-item.ant-select-item-option.ant-select-item-option-active {
  background: #f4f4f4;
}
.ant-select-item.ant-select-item-option:hover {
  background: #f4f4f4;
}

.ant-picker-calendar-date-content {
  display: none;
}

td.ant-picker-cell {
  opacity: 0.4;
  cursor: pointer;
}

td.ant-picker-cell.ant-picker-cell-in-view,
td.ant-picker-cell.ant-picker-cell-end.ant-picker-cell-in-view {
  opacity: 1;
}

td.ant-picker-cell.ant-picker-cell-disabled.ant-picker-cell-in-view {
  pointer-events: none;
  opacity: 0.4;
}

.worktualcarosuelmain {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 336px;
}
.worktualcarosuelmain svg {
  min-width: 36px;
  min-height: 36px;
  cursor: pointer;
  position: absolute;
  z-index: 99;
  top: 52px;
}
.worktualcarosuelmain svg:nth-child(1) {
  left: 10px;
}
.worktualcarosuelmain svg:nth-last-child(1) {
  right: 0;
}
.worktualcarosuelmain svg.disable {
  opacity: 0;
  pointer-events: none;
}
.worktualcarosuelmain .worktualcarosuelblock {
  border-radius: 12px;
  overflow: hidden;
  background: var(--widgetChatMessageColor);
  width: 260px;
  transition: 2s ease;
}
.worktualcarosuelmain .worktualcarosuelblock .worktualcarosuelimages {
  height: 146px;
  width: 100%;
  overflow: hidden;
  margin: 0 0 16px;
}
.worktualcarosuelmain .worktualcarosuelblock .worktualcarosuelimages img {
  width: 100% !important;
  height: 100%;
  object-fit: contain;
  background: var(--widgetChatMessageColor);
}
.worktualcarosuelmain .worktualcarosuelblock p {
  color: var(--dynamicAgentMessageTextColor);
  font-size: 12px;
  font-family: "interlight";
  line-height: 17px;
  margin: 0;
  padding: 0 12px;
  overflow: hidden;
  width: 90%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.worktualcarosuelmain .worktualcarosuelblock h3 {
  color: var(--dynamicAgentMessageTextColor);
  font-family: "intersemibold";
  font-size: 14px;
  line-height: 20px;
  margin: 8px 0 6px;
  padding: 0 12px;
}
.worktualcarosuelmain .worktualcarosuelblock h3.worktualpricing {
  font-family: "interbold";
  font-size: 15px;
}
.worktualcarosuelmain .worktualcarosuelblock h4 {
  color: var(--widgetActionMessageColor);
  font-size: 12px;
  font-family: "interlight";
  line-height: 18px;
  margin: 0 0 8px;
  padding: 0 12px;
}
.worktualcarosuelmain .worktualcarosuelblock .btns h5 {
  border-top: 1px solid #fff;
  color: var(--widgetActionMessageColor);
  text-align: center;
  font-family: "intersemibold";
  font-size: 14px;
  line-height: 20px;
  margin: 0;
  padding: 12px 0;
  cursor: pointer;
}

.forfiles {
  display: flex;
  align-items: center;
  gap: 12px;
}
.forfiles img {
  width: 46px !important;
}
.forfiles img.imagenotforfiles {
  width: 100% !important;
}

.articlebox {
  margin: -8px;
  display: block;
  text-align: center;
  min-width: 190px;
}
.articlebox p {
  padding: 10px;
  text-align: left;
}
.articlebox .articlemsgs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid var(--border-line, #D2D3D4);
  padding: 10px;
}
.articlebox .articlemsgs p {
  padding: 0 !important;
}

.articleexpand {
  position: absolute;
  background: #fff;
  z-index: 99;
  width: calc(100% - 32px);
  height: 100%;
  top: 0;
  left: 0;
  padding: 0 16px;
  overflow-y: scroll;
  /* Track */
  /* Handle */
  /* Handle on hover */
}
.articleexpand::-webkit-scrollbar {
  width: 4px;
  border-radius: 3px;
}
.articleexpand::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 3px;
}
.articleexpand::-webkit-scrollbar-thumb {
  background: #d3d6de;
  border-radius: 3px;
}
.articleexpand::-webkit-scrollbar-thumb:hover {
  background: #d3d6de;
  border-radius: 3px;
}
.articleexpand h4 {
  display: flex;
  align-items: center;
  gap: 12px;
}
.articleexpand h4 svg {
  cursor: pointer;
}
.articleexpand p {
  padding: 0 0 0 18px;
}

.fordropdowns {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #fff;
  border: 0.5px solid #000;
  border-radius: 6px;
  margin: 4px 0 0;
}
.fordropdowns span.ant-select-selection-placeholder {
  color: #000;
}

.worktualnamelists {
  width: 100%;
  display: block;
  margin: 12px 0 2px;
}

.checkoutBtn {
  margin: 12px -10px 0;
}
.checkoutBtn .checkoutProperties {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.checkoutBtn .checkoutImg {
  width: 40px;
  height: 40px;
}
.checkoutBtn .checkoutTitle {
  display: flex;
  flex-direction: column;
}
.checkoutBtn h5 {
  border-top: 1px solid #fff;
  color: var(--widgetActionMessageColor);
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  margin: 0 -15px;
  padding: 10px 12px;
  cursor: pointer;
}

.variantsColour {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  margin: 4px 0 8px;
  width: 100%;
}
.variantsColour .variantsChild {
  width: 24px;
  height: 18px;
  border: 1px solid var(--widgetChatMessageColor);
  display: flex;
  padding: 1px;
  border-radius: 4px;
  cursor: pointer;
}
.variantsColour .variantsChild p {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  border-radius: 4px;
}

.variationsworktual {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 8px 12px 16px 12px;
}
.variationsworktual .fordropdowns {
  margin: 0;
  width: calc(100% - 104px);
}
.variationsworktual .worktualcounters {
  width: 90px;
}

.worktualcounters {
  display: flex;
  align-items: center;
  border: 0.5px solid;
  justify-content: space-between;
  border-radius: 6px;
  height: 30px;
  background: #fff;
}
.worktualcounters .worktualcountersnumber {
  cursor: pointer;
  font-size: 20px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  align-content: center;
}
.worktualcounters .worktualcountersnumber svg {
  position: unset;
  min-width: auto;
  min-height: auto;
}
.worktualcounters input {
  width: 30px;
  height: 28px;
  border: 0;
  appearance: none;
  text-align: center;
  appearance: none;
  font-size: 14px;
  font-family: "intermedium";
}
.worktualcounters input:focus-visible {
  border: 0;
  box-shadow: none;
  outline: 0;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  appearance: none;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.content-wrapper {
  display: flex;
  overflow-x: scroll;
  gap: 16px;
  padding: 0 38px;
  scrollbar-width: none;
}
.content-wrapper::-webkit-scrollbar {
  height: 0;
  width: 0;
}

@keyframes geowJn {
  0% {
    opacity: 0;
    transform: translateY(32px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
@keyframes geowJnside {
  0% {
    opacity: 0;
    transform: translateX(32px);
  }
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}
.worktualshopping {
  margin: 8px 0 0;
}
.worktualshopping .worktualshoppingproperties {
  border-radius: 8px;
  border: 1px solid #D2D3D4;
  background: #FFF;
  gap: 8px;
  padding: 6px;
  width: 210px;
  margin: 0 0 8px;
}
.worktualshopping .worktualshoppingproperties:nth-last-child(1) {
  margin-bottom: 12px;
}
.worktualshopping .worktualshoppingproperties .checkoutImg {
  border-radius: 4px;
  overflow: hidden;
  height: 50px;
  background: #f4f4f4;
  display: flex;
  align-items: center;
}
.worktualshopping .worktualshoppingproperties .checkoutImg img {
  object-fit: contain !important;
  height: auto !important;
  width: 100%;
}
.worktualshopping .worktualshoppingproperties .shopleftworktual {
  display: flex;
  align-items: center;
  gap: 10px;
  width: calc(100% - 76px);
}
.worktualshopping .worktualshoppingproperties .shopleftworktual .worktualcounters {
  width: 76px;
  height: 24px;
  margin: 4px 0 0;
  justify-content: space-evenly;
}
.worktualshopping .worktualshoppingproperties .shopleftworktual .worktualcounters input {
  height: 22px;
  margin: 0;
  width: 20px;
}
.worktualshopping .worktualshoppingproperties .shopleftworktual .worktualcountersnumber {
  padding: 0 6px;
}
.worktualshopping .worktualshoppingproperties .checkoutTitle {
  width: calc(100% - 50px);
}
.worktualshopping .worktualshoppingproperties .checkoutTitle p {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-family: "intersemibold" !important;
}
.worktualshopping .worktualshoppingproperties .worktualshoppricelists {
  display: grid;
  justify-items: end;
  align-content: space-around;
  width: 140px;
}
.worktualshopping .worktualshoppingproperties .worktualshoppricelists .worktualshopprice {
  font-family: "intersemibold" !important;
}
.worktualshopping .worktualshoppingproperties .worktualshoppricelists .worktualshoppricediscount {
  font-family: "interregular" !important;
  color: #DE003D !important;
  text-decoration: line-through;
}

.reswork h5 {
  display: grid;
  justify-items: center;
}
.reswork h5 span {
  font-size: 12px;
  font-family: "interlight";
}

.worktualwix {
  padding: 0 16px;
}
.worktualwix input {
  border-radius: 6px;
  border: 1px solid var(--true-black-300, #D2D3D4);
  background: var(--Color-Black-White, #FFF);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.04);
  height: 38px;
  width: calc(100% - 24px);
  color: #252526;
  padding: 0 12px;
}
.worktualwix input:focus-visible {
  outline: 0;
}
.worktualwix label {
  color: #828385;
  font-family: "interregular";
  font-size: 14px;
  line-height: normal;
  padding: 16px 0 4px;
  width: 100%;
  display: block;
}
.worktualwix.worktualwixdivide {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 16px;
}
.worktualwix.worktualwixdivide .worktualwixhalf {
  width: 50%;
}
.worktualwix.worktualwixdivide span {
  color: #828385;
}
.worktualwix .worktualexpires {
  display: flex;
  align-items: center;
  border-radius: 6px;
  border: 1px solid var(--true-black-300, #D2D3D4);
  background: var(--Color-Black-White, #FFF);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  height: 38px;
}
.worktualwix .worktualexpires input {
  border: 0;
  box-shadow: none;
  border-radius: 0;
  height: 36px;
  padding: 0 8px;
}
.worktualwix .worktualexpires input:nth-child(1) {
  text-align: right;
  width: 24px;
}
.worktualwix button {
  border-radius: 6px;
  background: var(--true-black-800, #252526);
  display: flex;
  padding: 9px 18px;
  justify-content: center;
  align-items: center;
  font-family: "intersemibold";
  width: 100%;
  border: 0;
  color: #fff;
  font-size: 14px;
  height: 40px;
  margin: 25px 0 0;
}
.worktualwix .worktualicondivide {
  position: relative;
}
.worktualwix .worktualicondivide svg {
  position: absolute;
  right: 12px;
  top: 12px;
}

iframe {
  border: 0;
}

.footertopspace {
  padding: 7px 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: -14px 0 0;
}
.footertopspace .footercopys {
  white-space: nowrap;
  margin: 0;
}
.footertopspace .footercopys p {
  border: 0;
  padding: 0;
  font-size: 10px;
}
.footertopspace p {
  margin: 0;
  color: #757676;
  font-size: 8px;
  font-family: "interregular";
  line-height: 14px;
  text-align: left;
  border-left: 1px solid #d4d3d2;
  padding-left: 12px;
}

img.pdfFiledoc,
img.lftFiledoc {
  min-width: 42px;
  min-height: 42px;
  object-fit: fill;
  width: 42px !important;
  height: 42px !important;
}

img.imgFiledoc {
  width: 100%;
  border-radius: 4px;
}

.worktualattachs {
  border-radius: 6px;
  border: 1px dashed #505152;
  padding: 12px 18px;
  display: flex;
  cursor: pointer;
  width: max-content;
}
.worktualattachs [type=file] {
  height: 0;
  overflow: hidden;
  width: 0;
}
.worktualattachs [type=file] + label {
  display: flex;
  position: relative;
  transition: all 0.3s;
  vertical-align: middle;
  align-items: center;
  gap: 12px;
}
.worktualattachs label span {
  color: #575CFF;
  display: grid;
  font-size: 12px;
  line-height: 18px;
}
.worktualattachs label span span {
  color: #252526;
}

.newecomm {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.mics {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  cursor: pointer;
  position: relative;
}
.mics:before {
  content: "";
  border-radius: 50%;
  opacity: 2;
  z-index: -1;
  position: absolute;
  width: 28px;
  height: 28px;
}
.mics svg {
  padding: 8px;
}
.mics .lanpopup {
  border-radius: 3px;
  background: var(--true-black-800, #252526);
  display: inline-flex;
  padding: 4px 8px 4px 8px;
  align-items: center;
  color: #fff;
  font-family: "intermedium";
  font-size: 10px;
  line-height: 16px;
  text-decoration-line: underline;
  white-space: nowrap;
  position: absolute;
  right: 0;
  top: 36px;
  display: none;
}
.mics .lanpopup:before {
  display: block;
  position: absolute;
  top: -12px;
  height: 2px;
  content: "";
  border-right: solid 7px transparent;
  border-left: solid 7px transparent;
  border-bottom: solid 10px #252526;
  right: 7px;
}
.mics:hover .lanpopup {
  display: block;
}

.mics.activates {
  background: #D2D3D4;
  cursor: pointer;
}
.mics.activates:before {
  background: rgba(210, 211, 212, 0.4588235294);
  animation: bounce 0.95s ease-in-out infinite 0.7s;
  z-index: 9;
}

@keyframes bounce {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.4);
  }
  75% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.3);
  }
}
.reactInputPh:hover .flag-dropdown,
.reactInputPh:hover .formInputHeight,
.reactInputPh .country-list .search:hover {
  border-color: var(--widgetActionMessageColor) !important;
}

.chatpreviewleftview {
  flex-direction: row-reverse;
  gap: 20px;
}
.chatpreviewleftview .welcomemessage::after {
  right: unset;
  left: -17px;
  transform: rotate(270deg);
}
.chatpreviewleftview .welcomemessage::before {
  right: unset;
  left: -15px;
  transform: rotate(270deg);
}
.chatpreviewleftview .welcomemessage img {
  right: -11px;
  left: unset;
}

.leftagentchat p ul {
  flex-direction: column;
}
.leftagentchat p ul li {
  list-style: disc;
}
.leftagentchat p ol {
  flex-direction: column;
}
.leftagentchat p ol li {
  list-style: num;
}`, "",{"version":3,"sources":["webpack://./src/variable.scss","webpack://./src/chatPreview.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,kBAAA;EACA,mBAAA;EACA,+DAAA;ACEF;ADAA;EACE,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,+DAAA;ACEF;ADAA;EACE,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,+DAAA;ACEF;ADAA;EACE,wBAAA;EACA,kBAAA;EACA,mBAAA;EACA,+DAAA;ACEF;ADAA;EACE,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,+DAAA;ACEF;ADAA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,+DAAA;ACEF;ADAA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;ACEF;ADAA;EACE,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;ACEF;ADkHA;EACE,+BAAA;EACA,0BAAA;EACA,uBAAA;EACA,yBAAA;EACA,iCAAA;EACA,yCAAA;EACA,mCAAA;EACA,mCAAA;EACA,8BAAA;EACA,oCAAA;EACA,wCAAA;EACA,uCAAA;EACA,0CAAA;AChHF;;ADmHA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AChHF;;AApEA;EACE,eAAA;EACA,WAAA;EACA,eAAA;AAuEF;AArEE;EACE,UAAA;EACA,aAAA;EACA,qBAAA;EACA,SAAA;EAGA,sCAAA;EACA,kBAAA;AAqEJ;;AAjEA;EACE;IACE,mBAAA;EAoEF;AACF;AAjEA;EACE,+BAAA;EACA,qCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,eAAA;EACA,gBAAA;EACA,2BAAA;AAkEF;AAhEE;EACE,aAAA;AAkEJ;AA/DE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;AAiEJ;AA9DE;EACE,WAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AAgEJ;ADjBE;ECpDA;IAQI,WAAA;EAiEJ;AACF;AA/DI;EACE,SAAA;AAiEN;;AApDA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAuDF;AArDE;EACE,oCAAA;EACA,oCAAA;EACA,yBAAA;AAuDJ;AApDE;EACE,+CAAA;EACA,+CAAA;AAsDJ;AApDI;EACE,0DAAA;EACA,0DAAA;EACA,yBAAA;AAsDN;AAlDE;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAoDJ;AAjDE;EACE,wCAAA;EACA,8BAAA;EACA,+BAAA;AAmDJ;AAhDE;EACE,wCAAA;EACA,8BAAA;EACA,+BAAA;AAkDJ;AA/CE;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAiDJ;AA/CI;EACE,oCAAA;EACA,oCAAA;EACA,yBAAA;AAiDN;AA7CE;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;AA+CJ;AA5CE;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AA8CJ;AA3CE;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;AA6CJ;AA1CE;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,0BAAA;EACA,qBAAA;AA4CJ;AAzCE;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AA2CJ;AAzCI;EACE,oCAAA;EACA,oCAAA;EACA,yBAAA;AA2CN;;AArCA,+CAAA;AACA;EACE,4CAAA;EACA,yBAAA;EACA,yCAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAwCF;;AArCA;EACE;IAGE,UAAA;IACA,2CAAA;EAsCF;EAtBA;IACE,uCAAA;IAIA,UAAA;EAqBF;AACF;AAjBA;EACE;IACE,UAAA;IACA,yCAAA;EAmBF;EAhBA;IACE,uCAAA;IACA,UAAA;EAkBF;AACF;AAfA;EACE;IACE,UAAA;IACA,kBAAA;IACA,2BAAA;IACA,mBAAA;EAiBF;EAdA;IACE,UAAA;IACA,gBAAA;IACA,wBAAA;IACA,iBAAA;EAgBF;AACF;AAbA;EACE,mBAAA;EACA;;;8BAAA;EAIA,UAAA;EACA,yBAAA;EAEA,yDAAA;EACA,4BAAA;EACA,yBAAA;AAcF;;AAXA;EACE,mBAAA;EACA;;;8BAAA;EAKA,yBAAA;EAGA,yBAAA;EACA,2BAAA;AAWF;;AACA;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EAEA,eAAA;EACA,SAAA;EACA,wCAAA;EACA,UAAA;EACA,WAAA;EAEA,4BAAA;EACA,gBAAA;AAAF;AAEE;EACE,qCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,QAAA;AAAJ;AAGE;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,iCAAA;EACA,iDAAA;EACA,kDAAA;EACA,8BAAA;EACA,mBAAA;AADJ;AAGI;EACE,UAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,yBAAA;AADN;AAGM;EACE,+BAAA;AADR;AAGQ;EACE,SAAA;EACA,eAAA;EACA,4BAAA;EACA,iBAAA;AADV;AAGU;EACE,0BAAA;AADZ;AAKQ;EACE,eAAA;EACA,eAAA;EACA,mBAAA;AAHV;AAKU;EACE,0BAAA;AAHZ;AASI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAPN;AASM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAPR;AAWI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,UAAA;AATN;AAWM;EACE,eAAA;EACA,8BAAA;AATR;AAWQ;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;AATV;AAYQ;EACE,cAAA;EACA,eAAA;EACA,YAAA;AAVV;AAgBE;EACE,cAAA;EACA,kBAAA;EAEA,cAAA;EACA,eAAA;AAfJ;AAkBE;EAGE,4BAAA;EACA,OAAA;EACA,YAAA;AAlBJ;;AAsBA;EACE,wCAAA;EACA,sBAAA;EACA,0EAAA;EACA,yBAAA;AAnBF;AA0BE;EAEE,aAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;AAzBJ;AA0CI;EACE,iBAAA;EACA,UAAA;AAxCN;ADvRE;EC6TE;IAKI,2BAAA;EAvCN;AACF;AA2CE;EACE,gBAAA;EACA,UAAA;EACA,aAAA;AAzCJ;AA2CI;EACE,cAAA;EACA,eAAA;EACA,wBAAA;EACA,mBAAA;AAzCN;AA4CI;EACE,yBAAA;EACA,gBAAA;AA1CN;AA4CM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AA1CR;AA4CQ;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,4BAAA;AA1CV;AAgDE;EACE,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EAIA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EAEA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCAAA;EACA,qBAAA;AAlDJ;AAsEI;EACE,WAAA;EACA,kBAAA;AApEN;AAsEM;EACE,UAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AApER;AAsEQ;EACE,aAAA;EACA,QAAA;EAEA,WAAA;AArEV;AAwEY;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAtEd;AAyEY;EAEE,gBAAA;EACA,YAAA;AAxEd;AA2EY;EACE,yCAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,sBAAA;EAEA,8BAAA;EACA,cAAA;AA1Ed;AA6Ec;EACE,SAAA;EACA,2BAAA;EACA,eAAA;EACA,0CAAA;EACA,sBAAA;AA3EhB;AA6EgB;EACE,0BAAA;AA3ElB;AA+Ec;EACE,0BAAA;EACA,0CAAA;AA7EhB;AAiFgB;EACE,YAAA;EACA,mBAAA;EACA,8CAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AA/ElB;AAiFkB;EACE,wBAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AA/EpB;AAqFY;EACE,WAAA;AAnFd;AA0FI;EAEE,kBAAA;AAzFN;AA2FM;EAEE,gBAAA;EACA,SAAA;EACA,qBAAA;AA1FR;AAqGY;EACE,iDAAA;EAEA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,2BAAA;EACA,eAAA;EAEA,cAAA;EACA,uBAAA;EACA,QAAA;AArGd;AAoIY;EACE,aAAA;EACA,QAAA;AAlId;AAqIY;EACE,WAAA;AAnId;AAuIU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iDAAA;EACA,kBAAA;EACA,iBAAA;AArIZ;AAuIY;EACE,YAAA;EACA,kBAAA;AArId;AA2IM;EAOE,aAAA;EACA,yBAAA;EACA,mBAAA;AA/IR;AAmJQ;EACE,2BAAA;EACA,6CAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iDAAA;EACA,mBAAA;EACA,iBAAA;EAEA,aAAA;EACA,sBAAA;AAlJV;AAoJU;EACE,0BAAA;AAlJZ;AAqJU;EACE,0BAAA;EACA,6CAAA;AAnJZ;AA6JE;EACE,aAAA;EACA,iBAAA;EACA,kBAAA;AA3JJ;AA6JI;EACE,6CAAA;EACA,eAAA;AA3JN;AAkKM;EACE,cAAA;EACA,eAAA;AAhKR;AAqKE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,gBAAA;AAnKJ;AAqKI;EACE,0CAAA;EACA,eAAA;AAnKN;AA0KM;EACE,cAAA;EACA,eAAA;AAxKR;;AA8KA;EAKE,cAAA;EACA,cAAA;AA/KF;;AAoLI;EACE,qBAAA;EACA,0BAAA;AAjLN;;AAsLA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;EACA,aAAA;AAnLF;AAqLE;EACE,cAAA;AAnLJ;;AAuLA;EACE,4BAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AApLF;AAsLE;EACE,2BAAA;AApLJ;;AAwLA;EACE,aAAA;EACA,kBAAA;AArLF;AAuLE;EACE,2BAAA;EAWA,UAAA;EAMA,WAAA;EAMA,oBAAA;AAzMJ;AAoLI;EACE,qBAAA;AAlLN;AAqLI;EACE,UAAA;EACA,kBAAA;AAnLN;AAuLI;EACE,uBAAA;EACA,kBAAA;AArLN;AAyLI;EACE,mBAAA;EACA,kBAAA;AAvLN;AA2LI;EACE,mBAAA;EACA,kBAAA;AAzLN;;AA8LA;EACE,gBAAA;EACA,YAAA;EACA,0EAAA;EAEA,yBAAA;AA5LF;AA8LE;EACE,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCAAA;EACA,qBAAA;EAEA,2BAAA;EACA,iBAAA;EACA,gBAAA;AA7LJ;AAsMI;EACE,eAAA;EACA,eAAA;EACA,0BAAA;AApMN;AAuMI;EACE,iBAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;AArMN;AAyMM;EAEE,iBAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;AAxMR;AA4MI;EACE,kBAAA;AA1MN;AA6MI;EACE,kBAAA;EACA,aAAA;AA3MN;AA6MM;EACE,SAAA;AA3MR;AA8MM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AA5MR;AA8MQ;EACE,0BAAA;AA5MV;AAkNE;EACE,gBAAA;AAhNJ;AAmNI;EACE,kBAAA;AAjNN;AAoNI;EACE,eAAA;EACA,YAAA;EAEA,qBAAA;EACA,2BAAA;EAEA,kBAAA;AApNN;AAsNM;EACE,6CAAA;AApNR;AAuNM;EACE,eAAA;EAEA,cAAA;EACA,2BAAA;AAtNR;AA0NI;EAGE,2BAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,8CAAA;EAEA,iBAAA;AA3NN;AA6NM;EACE,cAAA;AA3NR;AA8NM;EACE,qBAAA;AA5NR;AA+NM;EACE,eAAA;EACA,kCAAA;EAEA,2BAAA;AA9NR;AAkOI;EACE,mBAAA;EACA,YAAA;AAhON;AAkOM;EACE,2BAAA;AAhOR;AAmOM;EACE,eAAA;EACA,YAAA;EACA,2BAAA;EACA,gCAAA;EACA,WAAA;EACA,cAAA;EACA,8CAAA;EACA,kBAAA;AAjOR;AAmOQ;EACE,qBAAA;EACA,8CAAA;AAjOV;AAoOQ;EACE,YAAA;AAlOV;AAqOQ;EACE,cAAA;EACA,YAAA;AAnOV;AAuOM;EACE,WAAA;AArOR;AAuOQ;EACE,aAAA;AArOV;AAuOU;EACE,aAAA;AArOZ;AAyOQ;EACE,aAAA;AAvOV;AA2OU;EACE,cAAA;AAzOZ;AA2OY;EACE,cAAA;AAzOd;AA8OQ;EACE,YAAA;EACA,WAAA;AA5OV;AA8OU;EACE,iBAAA;EACA,cAAA;AA5OZ;AAgPQ;EACE,iBAAA;AA9OV;AAiPQ;EACE,aAAA;AA/OV;AAoPI;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,2BAAA;EACA,8CAAA;EACA,kBAAA;AAlPN;AAsPU;EACE,eAAA;EACA,yBAAA;EACA,2BAAA;AApPZ;AA4PQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;EACA,cAAA;AA1PV;AA4PU;EACE,0BAAA;AA1PZ;AA6PU;EACE,0BAAA;AA3PZ;AAkQM;EACE,SAAA;AAhQR;AAkQQ;EACE,cAAA;EACA,cAAA;AAhQV;;AAuQA;EACE,gBAAA;EACA,kBAAA;AApQF;;AAuQA;EACE,iBAAA;EACA,kBAAA;AApQF;;AAuQA;EAEE,oBAAA;AArQF;AAuQE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AArQJ;AAwQI;EACE,eAAA;AAtQN;AA0QE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;EACA,iBAAA;EACA,kBAAA;AAxQJ;;AA4QA;EAEE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EAGA,4BAAA;AA5QF;AAmRE;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AAjRJ;AAmRI;EACE,yBAAA;AAjRN;AAoRI;EACE,yBAAA;AAlRN;AAsRE;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AApRJ;AAsRI;EACE,eAAA;AApRN;AAuRI;EACE,yBAAA;AArRN;AAyRE;EACE,cAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;AAvRJ;AAyRI;EACE,kBAAA;EACA,QAAA;AAvRN;AA0RI;EACE,WAAA;EACA,gBAAA;EACA,2BAAA;EAEA,uBAAA;EACA,6BAAA;EACA,gBAAA;EACA,0BAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;AAzRN;AA2RM;EACE,cAAA;AAzRR;AA8RE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;AA5RJ;AA8RI;EACE,YAAA;AA5RN;AA+RI;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;AA7RN;AAgSI;EACE,yBAAA;AA9RN;AAkSE;EACE,kBAAA;EACA,YAAA;EACA,SAAA;AAhSJ;;AAqSE;EACE,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;AAlSJ;AAqSE;EACE,kBAAA;AAnSJ;;AAuSA;EACE,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;AApSF;AAsSE;EACE,WAAA;AApSJ;AAsSI;EACE,WAAA;EACA,eAAA;AApSN;AAySI;EACE,eAAA;EACA,iBAAA;AAvSN;AAySM;EACE,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAvSR;AA4SE;EACE,SAAA;EACA,UAAA;AA1SJ;;AA8SA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AA3SF;AA6SE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AA3SJ;;AA+SA;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AA5SF;;AA+SA;EACE,kBAAA;EACA,YAAA;EACA,uBAAA;AA5SF;AA+SE;EACE,SAAA;EACA,YAAA;AA7SJ;AAgTE;EACE,aAAA;AA9SJ;AAiTE;EACE,SAAA;EACA,aAAA;AA/SJ;AAiTI;EACE,gBAAA;EACA,eAAA;EACA,2BAAA;EACA,iBAAA;AA/SN;AAkTI;EACE,8BAAA;EACA,gCAAA;EACA,SAAA;AAhTN;AAoTE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAlTJ;AAoTI;EACE,gBAAA;EACA,mBAAA;AAlTN;AAoTM;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;AAlTR;AAqTM;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;AAnTR;AAwTE;EACE,SAAA;AAtTJ;AAwTI;EACE,eAAA;AAtTN;;AA4TE;EACE,cAAA;AAzTJ;;AA6TA;EACE,cAAA;EACA,eAAA;AA1TF;;AA6TA,UAAA;AACA;EACE,UAAA;EACA,kBAAA;AA1TF;;AA8TA;EACE,UAAA;EACA,kBAAA;AA3TF;;AA8TA,UAAA;AACA;EACE,uBAAA;EACA,kBAAA;AA3TF;;AA8TA,WAAA;AACA;EACE,mBAAA;EACA,kBAAA;AA3TF;;AA8TA,oBAAA;AACA;EACE,mBAAA;EACA,kBAAA;AA3TF;;AA8TA;EACE,eAAA;AA3TF;;AA+TA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,2BAAA;AA5TF;AA+TE;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,qCAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2BAAA;AA7TJ;AA+TI;EACE,iDAAA;EACA,sCAAA;AA7TN;AAgUI;EAEE,iDAAA;EACA,sCAAA;EACA,6CAAA;EACA,0BAAA;EACA,0BAAA;EACA,eAAA;AA/TN;AAmUE;EACE,aAAA;AAjUJ;;AAqUA;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;AAlUF;AAoUE;EACE,SAAA;EACA,iBAAA;AAlUJ;AAqUE;EACE,SAAA;AAnUJ;AAqUI;EACE,0BAAA;EACA,sCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,0BAAA;EACA,UAAA;AAnUN;AAsUI;EACE,sBAAA;AApUN;AAwUE;EACE,0BAAA;EACA,sCAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AAtUJ;;AA0UA;EACE,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,0BAAA;EACA,UAAA;AAvUF;AAyUE;EACE,sBAAA;AAvUJ;;AA2UA;EACE,WAAA;AAxUF;;AA4UA;EACE,eAAA;AAzUF;;AA4UA;EACE,YAAA;EACA,mBAAA;EACA,WAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;AAzUF;;AA6UA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,+CAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AA1UF;AA4UE;EACE,eAAA;EACA,WAAA;EACA,2BAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;AA1UJ;AA4UI;EACE,0BAAA;AA1UN;AA8UE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AA5UJ;AA+UE;EACE,WAAA;EACA,2DAAA;EACA,mCAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,wBAAA;EACA,YAAA;EACA,UAAA;AA7UJ;AAgVE;EACE,WAAA;EACA,iCAAA;EACA,mCAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,wBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;AA9UJ;AAiVE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,oCAAA;EACA,gBAAA;AA/UJ;AAkVE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAhVJ;AAkVI;EACE,kBAAA;EACA,WAAA;AAhVN;;AAwVE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,cAAA;AArVJ;AAuVI;EACE,cAAA;EACA,eAAA;EACA,4BAAA;EACA,kBAAA;AArVN;AAuVM;EACE,0BAAA;AArVR;AAyVI;EACE,yDAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;AAvVN;AA0VI;EACE,yDAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;AAxVN;AA2VI;EACE,0DAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;AAzVN;AA4VI;EACE,0DAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;AA1VN;;AA+VA;EACE,aAAA;EACA,kBAAA;AA5VF;AA8VE;EACE,2BAAA;EACA,cAAA;EACA,eAAA;AA5VJ;AA+VE;EACE,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;AA7VJ;AA+VI;EACE,2BAAA;EACA,cAAA;EACA,eAAA;AA7VN;AAgWI;EACE,YAAA;EACA,kBAAA;AA9VN;AAoWE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAlWJ;AAoWI;EACE,WAAA;AAlWN;AAqWI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAnWN;AAsWI;EACE,YAAA;AApWN;AAuWI;EACE,YAAA;EACA,kBAAA;AArWN;AAwWI;EACE,2BAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AAtWN;AA0WE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAxWJ;;AA8WE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AA3WJ;AA8WE;EACE,eAAA;AA5WJ;AA+WE;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AA7WJ;AA+WI;EACE,kBAAA;AA7WN;AAiXE;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,4BAAA;EACA,qBAAA;AA/WJ;AAiXI;EACE,yBAAA;AA/WN;;AAoXA;EAEE,kBAAA;AAlXF;AAoXE;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,OAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,2DAAA;AAlXJ;AAoXI;EACE,cAAA;EACA,eAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AAlXN;AAsXM;EACE,8BAAA;EACA,gCAAA;AApXR;AAyXE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAvXJ;AAyXI;EACE,kBAAA;AAvXN;AA2XE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,4BAAA;AAzXJ;AA2XI;EACE,yBAAA;AAzXN;;AA8XA;EACE,cAAA;AA3XF;;AA8XA;EACE,uBAAA;AA3XF;AA6XE;EACE,aAAA;AA3XJ;AA8XE;EACE,aAAA;AA5XJ;AA+XE;EACE,UAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AA7XJ;AAgYE;EACE,oDAAA;EACA,WAAA;EACA,YAAA;AA9XJ;AAgYI;EACE,aAAA;AA9XN;;AAoYA;EACE,kBAAA;AAjYF;;AAqYE;EACE,6BAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;AAlYJ;;AAsYA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;AAnYF;;AAsYA;EACE,mBAAA;EACA,yBAAA;EACA,eAAA;AAnYF;;AAsYA;EACE,qBAAA;AAnYF;;AAsYA;EACE,aAAA;AAnYF;;AAsYA;EACE,cAAA;EACA,2BAAA;AAnYF;;AAsYA;EACE,cAAA;EACA,gBAAA;EACA,2BAAA;AAnYF;;AAsYA;EACE,yBAAA;EACA,aAAA;AAnYF;;AAsYA;EACE,gCAAA;AAnYF;;AAsYA;EACE,yBAAA;EACA,kBAAA;AAnYF;;AAsYA;EACE,cAAA;EACA,2BAAA;AAnYF;;AAsYA;EACE,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAnYF;AAqYE;EACE,yBAAA;EACA,oCAAA;AAnYJ;;AAuYA;EACE,uBAAA;EACA,qBAAA;AApYF;;AAuYA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AApYF;;AAwYE;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,2BAAA;AArYJ;;AAyYA;EACE,2BAAA;EACA,eAAA;AAtYF;;AAyYA;EACE,2BAAA;EACA,eAAA;AAtYF;;AA2YA,qDAAA;AAGA,eAAA;AAGA;;CAAA;AAGA,yEAAA;AACA;EACE,mBAAA;EACA,+BAAA;AA5YF;;AA+YA;EACE,mBAAA;EACA,iBAAA;AA5YF;;AA+YA;;EAEE,cAAA;AA5YF;;AA+YA;EACE,kBAAA;AA5YF;;AA+YA,6CAAA;AAEA;EACE,kBAAA;AA7YF;;AAgZA;EACE,uBAAA;EACA,cAAA;EACA,0BAAA;EACA,gBAAA;AA7YF;;AAgZA,2CAAA;AACA;EACE,qBAAA;AA7YF;;AAgZA;EACE,gBAAA;AA7YF;;AAgZA;EACE,aAAA;EACA,WAAA;AA7YF;;AAgZA,sDAAA;AACA;EACE,+BAAA;EACA,gBAAA;AA7YF;;AAgZA,qDAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;AA7YF;;AAgZA;EACE,yBAAA;AA7YF;;AAgZA;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AA7YF;;AAgZA,gFAAA;AACA;EACE,kBAAA;AA7YF;;AAgZA;EACE,UAAA;AA7YF;;AAgZA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;AA7YF;;AAgZA;EACE,mBAAA;AA7YF;;AAgZA;EACE,UAAA;AA7YF;;AAgZA;EACE,UAAA;EACA,gBAAA;AA7YF;;AAgZA;;EAEE,WAAA;AA7YF;;AAgZA;;EAEE,UAAA;AA7YF;;AAgZA;;EAEE,UAAA;AA7YF;;AAgZA;EACE,UAAA;AA7YF;;AAiZA,0CAAA;AACA;EACE,gCAAA;AA9YF;;AAiZA;EACE,gBAAA;AA9YF;;AAiZA;EACE,gBAAA;EACA,cAAA;AA9YF;;AAiZA;EACE,kBAAA;AA9YF;;AAiZA,sDAAA;AACA;;EAEE,+BAAA;AA9YF;;AAiZA;EACE,6BAAA;EACA,gCAAA;AA9YF;;AAkZA,6CAAA;AACA,8BAAA;AACA;EACE,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;AA/YF;;AAoZA,6CAAA;AACA,kCAAA;AACA;EACE,aAAA;AAjZF;;AAoZA;EACE,WAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAjZF;;AAqZA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AAlZF;;AAyZA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;AAtZF;AAwZE;EACE,WAAA;EACA,8BAAA;EACA,yBAAA;EACA,WAbQ;EAcR,UAdQ;EAeR,mBAdQ;EAeR,kBAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;AAtZJ;AAwZI;EACE,qBAAA;EACA,iBAAA;AAtZN;AAyZI;EACE,qBAAA;EACA,iBAAA;AAvZN;;AA6ZA;EACE;IACE,YAAA;EA1ZF;EA6ZA;IACE,UAAA;EA3ZF;EA8ZA;IACE,YAAA;EA5ZF;AACF;AA+ZA;EACE,kBAAA;EACA,QAAA;AA7ZF;;AAgaA;EACE,aAAA;EACA,mBAAA;EACA,kCAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;AA7ZF;AA+ZE;EACE,oBAAA;AA7ZJ;;AAkaA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,wCAAA;EACA,uCAAA;EACA,WAAA;AA/ZF;AAiaE;EACE,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,4EAAA;EACA,gBAAA;AA/ZJ;AAkaE;EACE,cAAA;EACA,eAAA;EACA,4BAAA;EACA,iBAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AAhaJ;AAkaI;EACE,eAAA;AAhaN;AAoaE;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;AAlaJ;AAoaI;EACE,gCAAA;EACA,yBAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAlaN;AAoaM;EACE,YAAA;AAlaR;AAqaM;EACE,YAAA;AAnaR;AAyaE;EACE,gBAAA;EACA,kDAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;AAvaJ;AA2aI;EACE,SAAA;EACA,UAAA;AAzaN;AA2aM;EACE,cAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAzaR;AA2aQ;EACE,mBAAA;AAzaV;AAgbE;EACE,cAAA;AA9aJ;AAgbI;EACE,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kDAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;AA9aN;AAkbE;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAhbJ;AAkbI;EACE,mBAAA;AAhbN;;AAqbA;EAUE;;KAAA;AAzbF;AAgbE;EACE,WAAA;EACA,aAAA;EACA,SAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;AA9aJ;AAqbE;EACE,kBAAA;AAnbJ;AAsbE;EACE,mBAAA;AApbJ;AAubE;EACE,2BAAA;EACA,iBAAA;AArbJ;AAwbE;EACE,4BAAA;AAtbJ;AAybE;EACE,gBAAA;AAvbJ;AA0bE;EACE,gBAAA;AAxbJ;AA2bE;EACE,2BAAA;EACA,iBAAA;AAzbJ;AA4bE;EACE,gBAAA;AA1bJ;;AA8bA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA3bF;;AA8bA;EACE,yBAAA;EACA,0BAAA;EACA,8BAAA;EACA,kCAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;AA3bF;;AA8bA;EACE,cAAA;AA3bF;;AA8bA;EACE,gBAAA;AA3bF;;AAicI;EACE,kBAAA;AA9bN;AAgcM;EACE,+CAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AA9bR;;AAocA;;;;EAIE,sDAAA;AAjcF;;AAocA;EACE,oDAAA;AAjcF;;AAocA;EACE,sBAAA;AAjcF;;AAqcA;EACE,YAAA;EACA,WAAA;AAlcF;;AAqcA;EACE,YAAA;EACA,WAAA;AAlcF;AAocE;EACE,qBAAA;AAlcJ;;AAucA;EACE,+CAAA;EACA,+CAAA;EACA,kBAAA;EACA,mDAAA;AApcF;;AAucA;;EAEE,2BAAA;AApcF;;AAucA;EACE,wBAAA;EACA,mBAAA;AApcF;AAscE;EACE,eAAA;EACA,cAAA;AApcJ;;AAwcA;EACE,WAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AArcF;;AAycE;EACE,aAAA;AAtcJ;AA0cI;EACE,cAAA;AAxcN;;AA8cE;EACE,aAAA;AA3cJ;AA+cI;EACE,cAAA;AA7cN;;AAkdA;EACE,WAAA;AA/cF;AAidE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA/cJ;AAidI;EACE,mBAAA;EACA,aAAA;EACA,cAAA;EACA,0BAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AA/cN;AAidM;EACE,0BAAA;AA/cR;AAkdM;EACE,0BAAA;AAhdR;;AAsdA;EACE;IACE,kBAAA;EAndF;EAsdA;IACE,mBAAA;EApdF;AACF;AAudA;EACE,6BAAA;EACA,gCAAA;EACA,cAAA;EACA,eAAA;AArdF;AAudE;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;AArdJ;AAudI;EACE,qCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AArdN;AAydE;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,QAAA;AAvdJ;AAydI;EACE,UAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;EACA,wBAAA;EACA,+CAAA;EACA,0BAAA;AAvdN;AAydM;EACE,qDAAA;AAvdR;AA6dM;EACE,oCAAA;EACA,oBAAA;AA3dR;;AAieA;EACE,iDAAA;EACA,uCAAA;EACA,kBAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;AA9dF;;AAieA;EACE,YAAA;AA9dF;AAgeE;EACE,oCAAA;AA9dJ;;AAkeA;EACE,aAAA;EACA,eAAA;EACA,cAAA;AA/dF;AAieE;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;EACA,wBAAA;EACA,YAAA;EACA,eAAA;AA/dJ;AAieI;EACE,UAAA;AA/dN;;AAoeA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,yCAAA;EACA,kBAAA;EACA,2DAAA;EACA,cAAA;EACA,8DAAA;EACA,gBAAA;AAjeF;AAmeE;EACE,WAAA;EACA,eAAA;AAjeJ;AAoeE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AAleJ;AAoeI;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;EACA,uDAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AAleN;AAoeM;EACE,iDAAA;AAleR;AAqeM;EACE,iDAAA;AAneR;;AAyeA;EACE,qBAAA;EACA,uBAAA;AAteF;;AAyeA;EACE,aAAA;AAteF;;AAyeA;EACE,kCAAA;EACA,mBAAA;EACA,2BAAA;AAteF;;AAyeA;EACE,kCAAA;EACA,oBAAA;AAteF;;AA0eA;EACE,8DAAA;EACA,qBAAA;EACA,2BAAA;EACA,WAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;AAveF;AAyeE;EACE,aAAA;AAveJ;;AA4eE;EACE,oCAAA;EACA,0BAAA;EACA,qDAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,kBAAA;AAzeJ;AA4eE;EACE,qCAAA;EACA,0BAAA;EACA,qDAAA;AA1eJ;;AA8eA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AA3eF;;AA8eA;EACE,oBAAA;EACA,2BAAA;EACA,6BAAA;EACA,uBAAA;EACA,sBAAA;AA3eF;;AA8eA;EACE,qDAAA;EACA,qCAAA;AA3eF;;AA8eA;EACE,2BAAA;AA3eF;;AA8eA;EACE,qBAAA;AA3eF;;AA8eA;;EAEE,oDAAA;AA3eF;;AA8eA;EACE,mBAAA;EACA,yCAAA;EACA,eAAA;AA3eF;AA6eE;EACE,SAAA;EACA,eAAA;AA3eJ;;AA+eA;EACE,2DAAA;EACA,kBAAA;EACA,cAAA;EACA,8DAAA;AA5eF;;AAgfE;EACE,4DAAA;AA7eJ;AA+eI;EACE,0CAAA;EACA,iEAAA;EACA,kBAAA;AA7eN;;AAkfA;EACE,kDAAA;EACA,gBAAA;EACA,cAAA;AA/eF;;AAmfE;EACE,mBAAA;AAhfJ;AAmfE;EACE,mBAAA;AAjfJ;;AAqfA;EACE,aAAA;AAlfF;;AAqfA;EACE,YAAA;EACA,eAAA;AAlfF;;AAqfA;;EAEE,UAAA;AAlfF;;AAqfA;EACE,oBAAA;EAEA,YAAA;AAnfF;;AAsfA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;AAnfF;AAqfE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AAnfJ;AAqfI;EACE,UAAA;AAnfN;AAsfI;EACE,QAAA;AApfN;AAufI;EACE,UAAA;EACA,oBAAA;AArfN;AAyfE;EACE,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,YAAA;EACA,mBAAA;AAvfJ;AA0fI;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAxfN;AA0fM;EACE,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,yCAAA;AAxfR;AA4fI;EACE,0CAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AA1fN;AA6fI;EACE,0CAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AA3fN;AA8fM;EACE,wBAAA;EACA,eAAA;AA5fR;AAggBI;EACE,sCAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AA9fN;AAkgBM;EACE,0BAAA;EACA,sCAAA;EACA,kBAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;AAhgBR;;AAsgBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAngBF;AAqgBE;EACE,sBAAA;AAngBJ;AAqgBI;EACE,sBAAA;AAngBN;;AAwgBA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AArgBF;AAugBE;EACE,aAAA;EACA,gBAAA;AArgBJ;AAwgBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iDAAA;EACA,aAAA;AAtgBJ;AAwgBI;EACE,qBAAA;AAtgBN;;AA2gBA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,wBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,kBAAA;EAOA,UAAA;EAMA,WAAA;EAMA,oBAAA;AAxhBF;AAugBE;EACE,UAAA;EACA,kBAAA;AArgBJ;AAygBE;EACE,uBAAA;EACA,kBAAA;AAvgBJ;AA2gBE;EACE,mBAAA;EACA,kBAAA;AAzgBJ;AA6gBE;EACE,mBAAA;EACA,kBAAA;AA3gBJ;AA8gBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA5gBJ;AA8gBI;EACE,eAAA;AA5gBN;AAghBE;EACE,mBAAA;AA9gBJ;;AAkhBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;AA/gBF;AAihBE;EACE,WAAA;AA/gBJ;;AAohBA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;AAjhBF;;AAohBA;EACE,oBAAA;AAjhBF;AAmhBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAjhBJ;AAohBE;EACE,WAAA;EACA,YAAA;AAlhBJ;AAqhBE;EACE,aAAA;EACA,sBAAA;AAnhBJ;AAshBE;EACE,0BAAA;EACA,sCAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AAphBJ;;AAwhBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AArhBF;AAuhBE;EACE,WAAA;EACA,YAAA;EACA,+CAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AArhBJ;AAuhBI;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AArhBN;;AA0hBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,2BAAA;AAvhBF;AAyhBE;EACE,SAAA;EACA,yBAAA;AAvhBJ;AA0hBE;EACE,WAAA;AAxhBJ;;AA8hBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AA3hBF;AA6hBE;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AA3hBJ;AA6hBI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AA3hBN;AA+hBE;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AA7hBJ;AA+hBI;EACE,SAAA;EACA,gBAAA;EACA,UAAA;AA7hBN;;AAkiBA;;EAGE,gBAAA;AA/hBF;;AAkiBA,YAAA;AACA;EACE,0BAAA;AA/hBF;;AAkiBA;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,qBAAA;AA/hBF;AAiiBE;EACE,SAAA;EACA,QAAA;AA/hBJ;;AAmiBA;EACE;IACE,UAAA;IACA,2BAAA;EAhiBF;EAmiBA;IACE,UAAA;IACA,0BAAA;EAjiBF;AACF;AAoiBA;EACE;IACE,UAAA;IACA,2BAAA;EAliBF;EAqiBA;IACE,UAAA;IACA,0BAAA;EAniBF;AACF;AAsiBA;EACE,eAAA;AApiBF;AAsiBE;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AApiBJ;AAsiBI;EACE,mBAAA;AApiBN;AAuiBI;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAriBN;AAuiBM;EACE,8BAAA;EACA,uBAAA;EACA,WAAA;AAriBR;AAyiBI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,wBAAA;AAviBN;AAyiBM;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;AAviBR;AAyiBQ;EACE,YAAA;EACA,SAAA;EACA,WAAA;AAviBV;AA2iBM;EACE,cAAA;AAziBR;AA6iBI;EACE,wBAAA;AA3iBN;AA6iBM;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uCAAA;AA3iBR;AA+iBI;EACE,aAAA;EACA,kBAAA;EACA,2BAAA;EACA,YAAA;AA7iBN;AA+iBM;EACE,uCAAA;AA7iBR;AAgjBM;EACE,sCAAA;EACA,yBAAA;EACA,6BAAA;AA9iBR;;AAqjBE;EACE,aAAA;EACA,qBAAA;AAljBJ;AAojBI;EACE,eAAA;EACA,yBAAA;AAljBN;;AAujBA;EACE,eAAA;AApjBF;AAsjBE;EACE,kBAAA;EACA,gDAAA;EACA,0CAAA;EACA,+CAAA;EACA,YAAA;EACA,wBAAA;EACA,cAAA;EACA,eAAA;AApjBJ;AAsjBI;EACE,UAAA;AApjBN;AAwjBE;EACE,cAAA;EACA,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AAtjBJ;AAyjBE;EACE,oBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AAvjBJ;AAyjBI;EACE,UAAA;AAvjBN;AA0jBI;EACE,cAAA;AAxjBN;AA4jBE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gDAAA;EACA,0CAAA;EACA,+CAAA;EACA,gBAAA;EACA,YAAA;AA1jBJ;AA4jBI;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AA1jBN;AA4jBM;EACE,iBAAA;EACA,WAAA;AA1jBR;AA+jBE;EACE,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,4BAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AA7jBJ;AAgkBE;EACE,kBAAA;AA9jBJ;AAgkBI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AA9jBN;;AAokBA;EACE,SAAA;AAjkBF;;AAokBA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAjkBF;AAmkBE;EACE,mBAAA;EACA,SAAA;AAjkBJ;AAmkBI;EACE,SAAA;EACA,UAAA;EACA,eAAA;AAjkBN;AAqkBE;EACE,SAAA;EACA,cAAA;EACA,cAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,kBAAA;AAnkBJ;;AAukBA;;EAEE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;AApkBF;;AAukBA;EACE,WAAA;EACA,kBAAA;AApkBF;;AAukBA;EACE,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;AApkBF;AAskBE;EACE,SAAA;EACA,gBAAA;EACA,QAAA;AApkBJ;AAukBE;EACE,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AArkBJ;AA0kBI;EACE,cAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;AAxkBN;AA0kBM;EACE,cAAA;AAxkBR;;AA8kBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AA3kBF;;AA8kBA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AA3kBF;AA6kBE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AA3kBJ;AA8kBE;EACE,YAAA;AA5kBJ;AA+kBE;EACE,kBAAA;EACA,0CAAA;EACA,oBAAA;EACA,wBAAA;EACA,mBAAA;EACA,WAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;AA7kBJ;AA+kBI;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,mCAAA;EACA,kCAAA;EACA,iCAAA;EACA,UAAA;AA7kBN;AAklBI;EACE,cAAA;AAhlBN;;AAqlBA;EACE,mBAAA;EACA,eAAA;AAllBF;AAolBE;EACE,6CAAA;EACA,iDAAA;EACA,UAAA;AAllBJ;;AAylBA;EACE;IACE,mBAAA;EAtlBF;EA2lBA;IACE,qBAAA;EAzlBF;EA4lBA;IACE,mBAAA;EA1lBF;EA6lBA;IACE,qBAAA;EA3lBF;AACF;AA+lBA;;;EAGE,wDAAA;AA7lBF;;AAgmBA;EACE,2BAAA;EACA,SAAA;AA7lBF;AAgmBI;EACE,YAAA;EACA,WAAA;EACA,yBAAA;AA9lBN;AAimBI;EACE,YAAA;EACA,WAAA;EACA,yBAAA;AA/lBN;AAkmBI;EACE,YAAA;EACA,WAAA;AAhmBN;;AAwmBI;EACE,sBAAA;AArmBN;AAumBM;EACE,gBAAA;AArmBR;AAymBI;EACE,sBAAA;AAvmBN;AAymBM;EACE,eAAA;AAvmBR","sourcesContent":["@font-face {\n  font-family: \"interregular\";\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"./fonts/Inter-Regular.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: \"intermedium\";\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"./fonts/Inter-Medium.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: \"intersemibold\";\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"./fonts/Inter-SemiBold.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: \"interbold\";\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"./fonts/Inter-Bold.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: \"interextrabold\";\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"./fonts/Inter-ExtraBold.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: \"interlight\";\n  font-style: normal;\n  font-weight: normal;\n  src: url(\"./fonts/Inter-Light.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: \"interthin\";\n  font-style: normal;\n  font-weight: 500;\n  src: url(\"./fonts/Inter-Thin.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: \"interextralight\";\n  font-style: normal;\n  font-weight: 500;\n  src: url(\"./fonts/Inter-ExtraLight.ttf\") format(\"truetype\");\n}\n\n$screen-big1699: 1699px;\n$screen-big1599: 1599px;\n$screen-big1399: 1399px;\n$screen-big1199: 1199px;\n$screen-big1023: 1023px;\n$screen-big900: 900px;\n$screen-big800: 800px;\n$screen-big767: 767px;\n$screen-big700: 700px;\n$screen-big600: 600px;\n$screen-big575: 575px;\n$screen-big400: 400px;\n$screen-big640: 640px;\n// Big1\n@mixin big01 {\n  @media (max-width: #{$screen-big1699}) {\n    @content;\n  }\n}\n// Big1\n@mixin big1 {\n  @media (max-width: #{$screen-big1599}) {\n    @content;\n  }\n}\n// Big2\n@mixin big2 {\n  @media (max-width: #{$screen-big1399}) {\n    @content;\n  }\n}\n// Big3\n@mixin big3 {\n  @media (max-width: #{$screen-big1199}) {\n    @content;\n  }\n}\n// Big4\n@mixin big4 {\n  @media (max-width: #{$screen-big1023}) {\n    @content;\n  }\n}\n// Big5\n@mixin big5 {\n  @media (max-width: #{$screen-big900}) {\n    @content;\n  }\n}\n// Big6\n@mixin big6 {\n  @media (max-width: #{$screen-big767}) {\n    @content;\n  }\n}\n\n// Big6\n@mixin big61 {\n  @media (min-width: #{$screen-big767}) {\n    @content;\n  }\n}\n\n\n// Big7\n@mixin big7 {\n  @media (max-width: #{$screen-big575}) {\n    @content;\n  }\n}\n// Big8\n@mixin big8 {\n  @media (max-width: #{$screen-big400}) {\n    @content;\n  }\n}\n\n// Big1\n@mixin hbig1 {\n  @media (max-height: #{$screen-big900}) {\n    @content;\n  }\n}\n// Big1\n@mixin hbig2 {\n  @media (max-height: #{$screen-big800}) {\n    @content;\n  }\n}\n// Big2\n@mixin hbig3 {\n  @media (max-height: #{$screen-big700}) {\n    @content;\n  }\n}\n// Big3\n@mixin hbig4 {\n  @media (max-height: #{$screen-big640}) {\n    @content;\n  }\n}\n\n// Main Variables\n\n$black: #fff;\n$logogreen: #02e79e;\n$buttonGreen: #00d499;\n$buttonGreenHover: #00b885;\n$buttonTextColor: #252625;\n$buttonWhite: #fff;\n$buttonWhiteHover: #00d499;\n$buttonTextColor: #252625;\n\n:root {\n  --widgetIconpostion: flex-start;\n  --widgetBorderRadius: 25px;\n  --widgetIconShape: 24px;\n  --widgetHeaderBG: #5b55ff;\n  --widgetChatMessageColor: #e3e4e5;\n  --widgetChatCustomerMessageColor: #e2e2fa;\n  --widgetActionMessageColor: #fa6e8f;\n  --widgetPreviewFont: \"interregular\";\n  --widgetStatusColor: \"#5B55FF\";\n  --widgetStatusBorderColor: \"#5B55FF\";\n  --widgetagentStatusTableColor: \"#575CFF\";\n  --widgetdispositionLinkColor: \"#575CFF\";\n  --widgetDeleteDispositionStatus: \"#5B55FF\";\n}\n\nbody {\n  font-size: 14px;\n  overflow: hidden;\n  line-height: 24px;\n  font-family: \"interregular\";\n}\n// h1 {\n//   font-size: 42px;\n//   font-family: \"interbold\";\n//   margin: 1rem 0 2rem;\n// }\n// h3 {\n//   font-size: 24px;\n//   font-family: \"InterSemibold\";\n//   margin: 0 0 0.5rem;\n// }\n// h4 {\n//   font-size: 20px;\n//   font-family: \"InterSemibold\";\n//   margin: 0 0 1rem;\n// }\n// h5 {\n//   font-size: 18px;\n//   font-family: \"InterSemibold\";\n//   margin: 0 0 0.5rem;\n// }\n","@import \"./variable.scss\";\n\n.chatPreview {\n  position: fixed;\n  bottom: 0px;\n  cursor: pointer;\n\n  &.chatright {\n    right: 0px;\n    display: flex;\n    align-items: flex-end;\n    gap: 20px;\n    // animation: 2s fadeInIcon;\n    // animation-fill-mode: forwards;\n    animation: cssAnimation 0s 4s forwards;\n    visibility: hidden;\n  }\n}\n\n@keyframes cssAnimation {\n  to {\n    visibility: visible;\n  }\n}\n\n.chatIcon {\n  background: var(--widgetIconBg);\n  border-radius: var(--widgetIconShape);\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  //border-radius: 12px;\n  min-width: 40px;\n  min-height: 40px;\n  transition: 8s opacity ease;\n\n  svg {\n    margin: 0 6px;\n  }\n\n  p {\n    margin: 0 10px 0 0;\n    font-size: 14px;\n    color: #fff;\n  }\n\n  &.chatIconclose {\n    bottom: 0px;\n    right: 0px;\n    position: fixed;\n    cursor: pointer;\n    animation: fadeIn 2s ease-in both;\n\n    @include big6 {\n      right: 10px;\n    }\n\n    &.chatIconPositionLeft {\n      left: 0px;\n    }\n\n    // @include big6 {\n    //   right: 25px;\n    // }\n\n    // @include big5 {\n    //   display: none;\n    // }\n  }\n}\n\n.primarybtn {\n  background-color: #00b885;\n  border: 1px solid #00b885;\n  color: #ffffff;\n  padding: 9px 18px;\n  width: 100%;\n  height: 38px;\n  font-family: \"intersemibold\";\n  text-align: center;\n  font-size: 14px;\n  box-shadow: none;\n  line-height: normal;\n\n  &:hover {\n    background-color: #00b885 !important;\n    border: 1px solid #00b885 !important;\n    color: #ffffff !important;\n  }\n\n  &.startbtn {\n    background-color: var(--dynamicprimaryButtonBg);\n    border: 1px solid var(--dynamicprimaryButtonBg);\n\n    &:hover {\n      background-color: var(--dynamicprimaryButtonBg) !important;\n      border: 1px solid var(--dynamicprimaryButtonBg) !important;\n      color: #ffffff !important;\n    }\n  }\n\n  span {\n    text-overflow: ellipsis;\n    max-width: 250px;\n    white-space: normal;\n    overflow: hidden;\n  }\n\n  &:hover {\n    background-color: var(--primaryButtonBg);\n    border: var(--primaryButtonBg);\n    color: var(--dynamicButtonText);\n  }\n\n  &:focus {\n    background-color: var(--primaryButtonBg);\n    border: var(--primaryButtonBg);\n    color: var(--dynamicButtonText);\n  }\n\n  &.primaryhiddenbtn {\n    background-color: #f5f6f7;\n    border: 1px solid #f5f6f7;\n    color: #aaabad;\n\n    &:hover {\n      background-color: #f5f6f7 !important;\n      border: 1px solid #f5f6f7 !important;\n      color: #aaabad !important;\n    }\n  }\n\n  &.primarybtnLeft {\n    max-width: 200px;\n    margin: 0 auto 0 0;\n    width: auto;\n  }\n\n  &.primarybtnCenter {\n    max-width: 200px;\n    margin: 0 auto;\n    text-align: center;\n    width: auto;\n    display: block;\n  }\n\n  &.primarybtnRight {\n    max-width: 200px;\n    margin: 0 0 0 auto;\n    width: auto;\n  }\n\n  &.primarylabel {\n    border: 1px solid #DCF5EE;\n    border-radius: 12px;\n    padding: 2px 8px;\n    color: #252526;\n    width: auto;\n    height: auto;\n    font-size: 10px;\n    background: #DCF5EE;\n    font-family: 'intermedium';\n    letter-spacing: 0.2px;\n  }\n\n  &.primaryhiddenbtn {\n    background-color: #f5f6f7;\n    border: 1px solid #f5f6f7;\n    color: #aaabad;\n\n    &:hover {\n      background-color: #f5f6f7 !important;\n      border: 1px solid #f5f6f7 !important;\n      color: #aaabad !important;\n    }\n  }\n}\n\n\n/* Apply the animation to the chatbot element */\n.animatechatbot {\n  animation: slideIn 0.5s ease-in-out forwards;\n  /* Animation properties */\n  /* Other styles for the chatbot element */\n  width: 200px;\n  height: 200px;\n  background-color: #ccc;\n}\n\n@keyframes slide-in-up {\n  0% {\n    // transform: translateY(0);\n    // transform: translateX(0px);\n    opacity: 0;\n    transform: translate(180px, 250px) scale(0);\n    // transform: translate(100px, 100px);\n  }\n\n  // 25% {\n  //   transform: translateY(75%);\n  //   opacity: 0.25;\n  // }\n  // 50% {\n  //   transform: translateY(50%);\n  //   opacity: 0.5;\n  // }\n  // 75% {\n  //   transform: translateY(25%);\n  //   opacity: 0.75;\n  // }\n  100% {\n    transform: translate(0px, 0px) scale(1);\n    // transform: translate(0px, 0px);\n    // transform: translateY(1);\n    // transform: translateX(1);\n    opacity: 1;\n  }\n}\n\n\n@keyframes slide-in-up {\n  0% {\n    opacity: 0;\n    transform: translate(5px, 250px) scale(0);\n  }\n\n  100% {\n    transform: translate(0px, 0px) scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes worktualChatfadeInUp {\n  from {\n    opacity: 0;\n    /* Start opacity */\n    transform: translateY(20px);\n    /* Start position */\n  }\n\n  to {\n    opacity: 1;\n    /* End opacity */\n    transform: translateY(0);\n    /* End position */\n  }\n}\n\n.chatbotlayout.worktualChatvisible {\n  visibility: visible;\n  /* -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both; */\n  opacity: 0;\n  /* Start with opacity 0 */\n  // position: relative;\n  animation: worktualChatfadeInUp 0.4s forwards ease-in-out;\n  transition: filter .3s ease;\n  /* Animation properties */\n}\n\n.chatbotlayout.worktualmobilevisible {\n  visibility: visible;\n  /* -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both; */\n  //opacity: 0;\n  /* Start with opacity 0 */\n  // position: relative;\n  //animation: worktualChatfadeInUp 1s forwards ease-in-out;\n  /* Animation properties */\n  border-radius: 0 !important;\n}\n\n\n\n// .chatbotlayout.visible {\n//   visibility: visible;\n//   opacity: 1;\n//   transform: translateY(0%);\n// }\n\n\n.chatbotlayout {\n  width: 365px;\n  visibility: hidden;\n  margin: 0;\n  //cursor: pointer;\n  position: fixed;\n  bottom: 0;\n  border-radius: var(--widgetBorderRadius);\n  right: 0px;\n  z-index: 99;\n  // box-shadow: 0px 25px 50px -12px rgba(0, 0, 0, 0.25);\n  transition: filter 0.3s ease;\n  overflow: hidden;\n\n  .chatIcon {\n    border-radius: var(--widgetIconShape);\n    width: 48px;\n    height: 48px;\n    position: absolute;\n    bottom: -85px;\n    cursor: pointer;\n    display: inline;\n    right: 0;\n  }\n\n  .chatHeader {\n    display: flex;\n    padding: 14px 22px;\n    gap: 16px;\n    background: var(--widgetHeaderBG);\n    border-top-left-radius: var(--widgetBorderRadius);\n    border-top-right-radius: var(--widgetBorderRadius);\n    justify-content: space-between;\n    align-items: center;\n\n    ul {\n      padding: 0;\n      list-style: none;\n      color: #ffffff;\n      margin: 0;\n      width: calc(100% - 100px);\n\n      li {\n        color: var(--dynamictextHeader);\n\n        h2 {\n          margin: 0;\n          font-size: 16px;\n          font-family: \"intersemibold\";\n          line-height: 22px;\n\n          &:first-letter {\n            text-transform: capitalize\n          }\n        }\n\n        p {\n          margin: 2px 0 0;\n          font-size: 12px;\n          line-height: normal;\n\n          &:first-letter {\n            text-transform: capitalize\n          }\n        }\n      }\n    }\n\n    .headerimg {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 8px;\n      overflow: hidden;\n      box-shadow: 0 0 1px rgba(0, 0, 0, 0.7098039216);\n      max-width: 42px;\n      max-height: 42px;\n      min-height: 42px;\n      min-width: 42px;\n\n      img {\n        width: 100%;\n        height: auto;\n        object-fit: initial;\n        max-width: 100%;\n      }\n    }\n\n    .rightcls {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 4px;\n      position: relative;\n      left: 10px;\n\n      svg {\n        cursor: pointer;\n        fill: var(--dynamictextHeader);\n\n        &:nth-child(1) {\n          padding: 0 0px;\n          min-height: 18px;\n          margin: 0 4px 0 0;\n        }\n\n        &:nth-child(2) {\n          padding: 2px 0;\n          min-width: 24px;\n          height: 16px;\n        }\n      }\n    }\n  }\n\n  .chatbtm {\n    padding: 8px 0;\n    text-align: center;\n    //color: var(--widgetChatCopyRight);\n    color: #aaabad;\n    font-size: 10px;\n  }\n\n  &.chatbotLayoutRight {\n    //animation: slide-in-up 0.3s ease-in-out;\n\n    transition: filter .3s ease;\n    left: 0;\n    right: unset;\n  }\n}\n\n.chatinfo {\n  background-image: var(--backgroundImage);\n  background-color: #fff;\n  border-radius: 0px 0px var(--widgetBorderRadius) var(--widgetBorderRadius);\n  border: 1px solid #e3e4e5;\n\n  // @include big6 {\n  //   border-radius: 0px;\n  //   box-shadow: none;\n  // }\n\n  .chatbottomview {\n    // height: 310px;\n    display: flex;\n    align-items: end;\n    height: calc(100vh - 200px);\n    overflow: hidden;\n    padding: 16px 0 0;\n    max-height: 500px;\n    transition: 0.3s ease;\n    // @include big3 {\n    //   height: 363px;\n    // }\n\n    // @include big7 {\n    //   // height: 363px;\n    //   height: calc(100vh - 126px);\n    // }\n\n    // @include big6 {\n    //   // height: 363px;\n    //   height: calc(100vh - 146px);\n    // }\n    // @include hbig4 {\n    //   height: 275px;\n    // }\n    &.withnofooter {\n      max-height: 568px;\n      padding: 0;\n\n      @include hbig3 {\n        height: calc(100vh - 132px);\n      }\n    }\n  }\n\n  .welcomeMessage {\n    text-align: left;\n    flex: auto;\n    padding: 16px;\n\n    h5 {\n      color: #00B885;\n      font-size: 20px;\n      font-family: 'interbold';\n      margin-bottom: 10px;\n    }\n\n    .welcomeList {\n      padding-inline-start: 0px;\n      list-style: none;\n\n      li {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        background-color: #E3E4E5;\n        margin-bottom: 8px;\n        border-radius: 6px;\n        padding: 8px 12px;\n        cursor: pointer;\n\n        h5 {\n          font-size: 14px;\n          color: #161717;\n          margin: 0px;\n          font-family: 'intersemibold';\n        }\n      }\n    }\n  }\n\n  .chatMessage {\n    display: flex;\n    align-items: end;\n    padding: 16px 12px 0 12px;\n    overflow-y: auto;\n    // position: absolute;\n    //right: -10%;\n    //max-height: 434px;\n    width: 100%;\n    max-width: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    //bottom: 54px;\n    scroll-behavior: smooth;\n    flex-direction: column-reverse;\n    align-items: normal;\n    height: 100%;\n    overflow: hidden;\n    overflow-y: scroll;\n    scrollbar-color: #bbbbbb #f5f5f5;\n    scrollbar-width: thin;\n    // @include big2 {\n    //   // max-height: calc(100vh - 534px);\n    //   width: 93%;\n    //   max-width: 93%;\n    // }\n\n    // @include big6 {\n    //   width: 93%;\n    //   max-width: 93%;\n    //   max-height: calc(100vh - 170px);\n    // }\n    // @include hbig4 {\n    //   max-height: 259px;\n    // }\n    // @include big7 {\n    //   max-height: 322px;\n    //   width: 92%;\n    //   max-width: 100%;\n    // }\n    .chatleftview {\n      width: 100%;\n      margin: 16px 0 8px;\n\n      ul.profilerounds {\n        padding: 0;\n        list-style: none;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        margin: 0px;\n\n        .left {\n          display: flex;\n          gap: 8px;\n          // margin: 0 0 4px 0;\n          width: 100%;\n\n          li {\n            &.lifirsts {\n              width: 32px;\n              height: 32px;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              border-radius: 50%;\n              overflow: hidden;\n              min-width: 32px;\n              min-height: 32px;\n            }\n\n            img {\n              //width: 100%;\n              object-fit: fill;\n              height: 100%;\n            }\n\n            .leftagentchat {\n              background: var(--widgetChatMessageColor);\n              border-radius: 12px;\n              padding: 8px 10px;\n              margin: 2px 0 0;\n              line-height: 21px;\n              word-break: break-word;\n              position: relative;\n              letter-spacing: -0.2px;\n              display: inline-flex;\n              flex-direction: column;\n              // align-items: flex-end;\n              justify-content: space-between;\n              max-width: 78%;\n              //animation: 300ms ease 0.1s 1 normal none running geowJn;\n\n              p {\n                margin: 0;\n                font-family: \"interregular\";\n                font-size: 14px;\n                color: var(--dynamicAgentMessageTextColor);\n                word-break: break-word;\n\n                &::first-letter {\n                  text-transform: capitalize;\n                }\n              }\n\n              a {\n                text-decoration: underline;\n                color: var(--dynamicAgentMessageTextColor);\n              }\n\n              &.worktualcouponmain {\n                .worktualcoupons {\n                  padding: 8px;\n                  border-radius: 10px;\n                  border: 1px dashed var(--border-line, #D2D3D4);\n                  background: var(--Color-Black-White, #FFF);\n                  display: flex;\n                  align-items: center;\n                  margin: 8px 0 0;\n\n                  p {\n                    width: calc(100% - 22px);\n                    text-align: center;\n                    font-size: 14px;\n                    font-family: \"intersemibold\";\n                    text-transform: uppercase;\n                    white-space: nowrap;\n                    padding: 0 12px;\n                  }\n                }\n              }\n            }\n\n            &:nth-child(2) {\n              width: 100%;\n            }\n          }\n        }\n      }\n    }\n\n    .chatrightview {\n      //margin-left: 40px;\n      margin: 16px 0 8px;\n\n      ul {\n\n        list-style: none;\n        margin: 0;\n        padding: 0 !important;\n        // margin: 0 0 4px 0;\n        //margin: 0 60px 4px 0;\n\n        .right {\n          // display: flex;\n          // gap: 8px;\n          // flex-direction: row-reverse;\n          // width: 94%;\n\n          li {\n            p {\n              background: var(--widgetChatCustomerMessageColor);\n              // background: #E2E2FA;\n              border-radius: 6px;\n              padding: 12px 12px 6px;\n              margin: 0 0 10px 0;\n              display: flex;\n              font-family: \"interregular\";\n              font-size: 12px;\n              // color: var(--widgetChatTextColor);\n              color: #ffffff;\n              overflow-wrap: anywhere;\n              gap: 8px;\n            }\n          }\n\n          .pdfimg {\n            // display: flex;\n            // align-items: center;\n            // gap: 8px;\n            // background: var(--widgetChatCustomerMessageColor);\n            // border-radius: 12px;\n            // margin-left: auto;\n            // padding: 10px;\n            // display: table;\n\n\n            // background: var(--widgetChatCustomerMessageColor);\n            // border-radius: 12px;\n            // padding: 10px;\n            // margin: 6px 0 0;\n            // display: table;\n            // font-family: \"interregular\";\n            // font-size: 14px;\n            // line-height: 21px;\n            // word-break: break-word;\n            // position: relative;\n            // letter-spacing: -0.2px;\n            // display: inline-flex;\n            // align-items: flex-end;\n            // justify-content: space-between;\n            // min-width: 80px;\n\n            a {\n              display: flex;\n              gap: 8px;\n            }\n\n            img {\n              width: 32px;\n            }\n          }\n\n          .imageInner {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            background: var(--widgetChatCustomerMessageColor);\n            border-radius: 6px;\n            padding: 6px 12px;\n\n            img {\n              width: 160px;\n              border-radius: 8px;\n            }\n          }\n        }\n      }\n\n      .rightChat {\n        // position: relative;\n        // color: black;\n        // word-break: break-word;\n        // line-height: 20px;\n        // font-size: 14px;\n        // width: 100%;\n        display: flex;\n        justify-content: flex-end;\n        align-items: center;\n        //gap: 16px;\n        // animation: 300ms ease 0.1s 1 normal none running geowJn;\n\n        .fileTitle {\n          font-family: \"interregular\";\n          color: var(--dynamicCustomerMessageTextColor);\n          font-size: 14px;\n          line-height: 21px;\n          letter-spacing: -0.2px;\n          background: var(--widgetChatCustomerMessageColor);\n          border-radius: 12px;\n          padding: 8px 10px;\n          //max-width: 80%;\n          display: flex;\n          word-break: break-word;\n\n          &::first-line {\n            text-transform: capitalize;\n          }\n\n          a {\n            text-decoration: underline;\n            color: var(--dynamicCustomerMessageTextColor);\n          }\n        }\n      }\n    }\n  }\n\n  // .chatMessagefoot {\n  //   max-height: 380px;\n  // }\n  .sendmail {\n    display: flex;\n    line-height: 10px;\n    margin: 0 12px 0 0;\n\n    span {\n      color: var(--dynamicCustomerMessageTextColor);\n      font-size: 10px;\n      // margin-top: 5px;\n\n      &:nth-child(1) {\n        // margin-right: 4px;\n      }\n\n      &:nth-child(2) {\n        margin: 0 -3px;\n        font-size: 18px;\n      }\n    }\n  }\n\n  .sendmailagent {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    line-height: 10px;\n    white-space: nowrap;\n    position: relative;\n    right: -2px;\n    top: 4px;\n    margin-left: 2px;\n\n    span {\n      color: var(--dynamicAgentMessageTextColor);\n      font-size: 10px;\n      // margin-top: 5px;\n\n      &:nth-child(1) {\n        // margin-right: 4px;\n      }\n\n      &:nth-child(2) {\n        margin: 0 -3px;\n        font-size: 18px;\n      }\n    }\n  }\n}\n\n.fileTitle {\n  // text-overflow: ellipsis;\n  // white-space: nowrap;\n  // overflow: hidden;\n  //max-width: 72%;\n  max-width: 72%;\n  display: block;\n}\n\n.rightChat {\n  .rightChat {\n    .fileTitle {\n      padding: 0 !important;\n      max-width: 100% !important;\n    }\n  }\n}\n\n.agentconnect {\n  text-align: center;\n  color: #161717;\n  font-size: 12px;\n  margin: 0 1px;\n  width: 92%;\n  line-height: 18px;\n  border-radius: 6px;\n  background: #F8F9F9;\n  font-family: \"interregular\";\n  display: block;\n  padding: 12px;\n\n  a {\n    color: #161717;\n  }\n}\n\n.chatconnecter {\n  font-family: \"intersemibold\";\n  text-align: center;\n  color: #656a6a;\n  font-size: 12px;\n  bottom: 130px;\n  margin: 7px;\n  width: 100%;\n  background-color: #f5f6f7;\n\n  span {\n    font-family: \"interregular\";\n  }\n}\n\n.chatmessagefooter {\n  margin-top: 0;\n  position: relative;\n\n  textarea {\n    max-height: 60px !important;\n\n    &:hover {\n      border-color: #00B885\n    }\n\n    &::-webkit-scrollbar {\n      width: 4px;\n      border-radius: 3px;\n    }\n\n    /* Track */\n    &::-webkit-scrollbar-track {\n      background: transparent;\n      border-radius: 3px;\n    }\n\n    /* Handle */\n    &::-webkit-scrollbar-thumb {\n      background: #d3d6de;\n      border-radius: 3px;\n    }\n\n    /* Handle on hover */\n    &::-webkit-scrollbar-thumb:hover {\n      background: #d3d6de;\n      border-radius: 3px;\n    }\n  }\n}\n\n.chatBody {\n  background: #fff;\n  padding: 0px;\n  border-radius: 0px 0px var(--widgetBorderRadius) var(--widgetBorderRadius);\n  //box-shadow: 0px 6px 10px -3px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e3e4e5;\n\n  .chatbotformtitle {\n    padding: 12px 16px 12px 24px;\n    overflow: hidden;\n    overflow-y: scroll;\n    scrollbar-color: #bbbbbb #f5f5f5;\n    scrollbar-width: thin;\n    // height: calc(100vh - 148px);\n    height: calc(100vh - 173px);\n    max-height: 500px;\n    margin: 0 0 14px;\n\n    // @include big1 {\n    // max-height: calc(100% - 500px);\n    // }\n    // @include hbig4 {\n    //   min-height: 199px;\n    //   max-height: 310px;\n    // }\n    h4 {\n      margin: 0 0 6px;\n      font-size: 14px;\n      font-family: 'intermedium';\n    }\n\n    p {\n      line-height: 19px;\n      color: #161717;\n      margin: 0;\n      font-size: 12px;\n    }\n\n    ul {\n      li {\n\n        line-height: 19px;\n        color: #161717;\n        margin: 0;\n        font-size: 12px;\n      }\n    }\n\n    &.chatmsgform {\n      overflow-y: hidden;\n    }\n\n    &.chatreqsuccess {\n      text-align: center;\n      padding: 12px;\n\n      .chatbotform {\n        margin: 0;\n      }\n\n      p {\n        font-size: 16px;\n        line-height: 24px;\n        margin-bottom: 0;\n\n        span {\n          font-family: \"intermedium\";\n        }\n      }\n    }\n  }\n\n  .chatbotform {\n    margin-top: 24px;\n\n    // margin: 16px 16px 0;\n    .ant-form-item {\n      margin: 0 0 10px 0;\n    }\n\n    .formInputHeight {\n      font-size: 14px;\n      height: 38px;\n      //border-color: var(--widgetInputBorder);\n      border-color: #D2D3D4;\n      font-family: \"interregular\";\n      //box-shadow: 0px 2px 3px rgba(12, 21, 35, 0.04);\n      border-radius: 6px;\n\n      &:hover {\n        border-color: var(--widgetActionMessageColor);\n      }\n\n      &::placeholder {\n        font-size: 14px;\n        // color: var(--widgetInputTextColor);\n        color: #828385;\n        font-family: \"interregular\";\n      }\n    }\n\n    .formtextareaHeight {\n      //border-color: var(--widgetInputBorder);\n      //border-color: #BDBEBF;\n      font-family: \"interregular\";\n      height: 80px;\n      border-color: #D2D3D4;\n      border-radius: 6px;\n      box-shadow: 0px 2px 3px rgba(12, 21, 35, 0.04);\n      //margin: -12px 0 0;\n      padding: 6px 12px;\n\n      .ant-input {\n        color: #00b885;\n      }\n\n      &:hover {\n        border-color: #00B885\n      }\n\n      &::placeholder {\n        font-size: 14px;\n        color: var(--widgetInputTextColor);\n        //color: #828385;\n        font-family: \"interregular\";\n      }\n    }\n\n    .formdropdown {\n      margin-bottom: 12px;\n      height: 40px;\n\n      span.ant-select-arrow {\n        margin-top: -1px !important;\n      }\n\n      .ant-select-selector {\n        font-size: 14px;\n        height: 40px;\n        font-family: \"interregular\";\n        border-color: #bdbebf !important;\n        width: 100%;\n        padding: 0 5px;\n        box-shadow: 0px 2px 3px rgba(12, 21, 35, 0.04);\n        border-radius: 6px;\n\n        &:hover {\n          border-color: #bdbebf;\n          box-shadow: 0px 2px 3px rgba(12, 21, 35, 0.04);\n        }\n\n        .ant-select-selection-item {\n          padding: 5px;\n        }\n\n        .ant-select-selection-placeholder {\n          color: #828385;\n          padding: 5px;\n        }\n      }\n\n      &.formdropdownsmall {\n        width: 60px;\n\n        .ant-picker-suffix {\n          display: none;\n\n          &:hover {\n            display: none;\n          }\n        }\n\n        .ant-picker-clear {\n          display: none;\n        }\n\n        .ant-picker-input {\n          input {\n            color: #828385;\n\n            &::placeholder {\n              color: #828385;\n            }\n          }\n        }\n\n        .ant-select-selector {\n          height: 32px;\n          width: 46px;\n\n          .ant-select-selection-item {\n            line-height: 20px;\n            color: #828385;\n          }\n        }\n\n        .ant-select-selection-placeholder {\n          line-height: 20px;\n        }\n\n        .ant-select-arrow {\n          display: none;\n        }\n      }\n    }\n\n    .formInputCalender {\n      width: 100%;\n      font-size: 14px;\n      height: 38px;\n      border-color: #bdbebf;\n      font-family: \"interregular\";\n      box-shadow: 0px 2px 3px rgba(12, 21, 35, 0.04);\n      border-radius: 6px;\n\n      .ant-picker-input {\n        input {\n          &::placeholder {\n            font-size: 14px;\n            color: #828385 !important;\n            font-family: \"interregular\";\n          }\n        }\n      }\n    }\n\n    .districtselection {\n      .ant-form-item-control-input-content {\n        label {\n          display: flex;\n          align-items: center;\n          gap: 6px;\n          background: #F0F1F2;\n          padding: 10px;\n          color: #252526;\n          font-family: \"intermedium\";\n          font-size: 14px;\n          line-height: 0;\n\n          &:nth-child(1) {\n            border-radius: 6px 6px 0 0;\n          }\n\n          &:nth-last-child(1) {\n            border-radius: 0 0 6px 6px;\n          }\n        }\n      }\n    }\n\n    .addressselection {\n      .formaddress {\n        margin: 0;\n\n        label {\n          display: block;\n          color: #828385;\n        }\n      }\n    }\n  }\n}\n\n.chatviewLeft {\n  text-align: left;\n  padding: 0 20% 0 0;\n}\n\n.chatviewRight {\n  text-align: right;\n  padding: 0 20% 0 0;\n}\n\n.footercopyright {\n  // border-top: 1px solid #e3e4e5;\n  padding: 0px 8px 8px;\n\n  .footercopys {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 6px;\n    margin: 0 0 6px;\n\n\n    img {\n      cursor: pointer;\n    }\n  }\n\n  p {\n    margin: 0;\n    color: #757676;\n    font-size: 10px;\n    font-family: \"interregular\";\n    line-height: 14px;\n    text-align: center;\n  }\n}\n\n.chatFooter {\n  // border-top: 1px solid #e3e4e5;\n  display: flex;\n  align-items: center;\n  padding: 10px 15px;\n  min-height: 50px;\n  // border-left: 1px solid #eef1f3;\n  // border-right: 1px solid #eef1f3;\n  border-radius: 0 0 12px 12px;\n  // border-bottom: 1px solid #eef1f3;\n\n  // @include big6 {\n  //   border-radius: 0px;\n  // }\n\n  .chatFooterinput {\n    background-color: #ffffff;\n    margin: 5px 0;\n    border-radius: 22px;\n    padding: 6px 8px 6px 10px;\n    display: flex;\n    width: 100%;\n    border: 1px solid #D2D3D4;\n    align-items: center;\n\n    &:hover {\n      border: 1px solid #252526;\n    }\n\n    &:focus-within {\n      border: 1px solid #252526;\n    }\n  }\n\n  .attach {\n    max-width: 30px;\n    line-height: 5px;\n    padding: 4px 5px 4px 4px;\n    border-radius: 50px;\n    margin-right: 6px;\n    cursor: pointer;\n\n    label {\n      cursor: pointer;\n    }\n\n    &:hover {\n      background-color: #EDEFF0;\n    }\n  }\n\n  .message {\n    color: #828385;\n    font-size: 13px;\n    width: 90%;\n    margin-right: auto;\n\n    label {\n      position: relative;\n      top: 2px;\n    }\n\n    .MessageInput {\n      width: 100%;\n      margin-bottom: 0;\n      min-height: 32px !important;\n      // max-height: 40px !important;\n      background: transparent;\n      border: 1px solid transparent;\n      box-shadow: none;\n      font-family: \"intermedium\";\n      color: #161717;\n      font-size: 14px;\n      padding-left: 8px;\n      -webkit-text-size-adjust: 100%;\n\n      &::placeholder {\n        color: #828385;\n      }\n    }\n  }\n\n  .chaticons {\n    color: #828385;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 4px 6px;\n    font-family: \"interregular\";\n    border-radius: 50px;\n    cursor: pointer;\n\n    img {\n      height: 23px;\n    }\n\n    span {\n      cursor: pointer;\n      font-size: 20px;\n      color: #828385;\n      position: relative;\n      margin-top: 0;\n    }\n\n    &:hover {\n      background-color: #EDEFF0;\n    }\n  }\n\n  .emojipicker {\n    position: absolute;\n    bottom: 90px;\n    left: 5px;\n  }\n}\n\n.invaliderror {\n  .ant-form-item-explain-error {\n    font-size: 12px;\n    margin: 4px 0 6px;\n    font-family: \"interregular\";\n    text-align: left;\n    line-height: normal;\n  }\n\n  &.invaliderroraddress {\n    margin: 2px 0 10px;\n  }\n}\n\n.textpdf {\n  width: 130px;\n  border: 1px solid #e3e4e5;\n  display: flex;\n  align-items: center;\n  padding: 5px 0;\n  border-radius: 8px;\n  justify-content: space-around;\n  height: 24px;\n  position: relative;\n\n  .left {\n    width: 30px;\n\n    img {\n      width: 24px;\n      margin-top: 8px;\n    }\n  }\n\n  .right {\n    p {\n      font-size: 10px;\n      line-height: 15px;\n\n      &:nth-child(1) {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        width: 90px;\n        white-space: nowrap;\n        line-height: 12px;\n        padding-top: 4px;\n      }\n    }\n  }\n\n  p {\n    margin: 0;\n    padding: 0;\n  }\n}\n\n.imagesAttach {\n  border-radius: 6px;\n  position: relative;\n  width: 44px;\n  height: 44px;\n\n  img {\n    width: 42px;\n    height: 42px;\n    border: 1px solid #00e2a4;\n    border-radius: 6px;\n    object-fit: cover;\n    margin: 0 0 0 6px;\n  }\n}\n\n.textpdfclose {\n  position: absolute;\n  top: -6px;\n  right: -10px;\n  width: 16px;\n  height: 16px;\n  background-color: #000000;\n  border-radius: 50%;\n  color: #ffffff;\n  z-index: 9;\n  text-align: center;\n  line-height: 15px;\n  cursor: pointer;\n}\n\n.chatBodymessageview {\n  border-radius: 6px;\n  width: 260px;\n  margin: 24px 0 10px 3px;\n\n\n  .chatbotformtitle {\n    margin: 0;\n    height: auto;\n  }\n\n  .callbackreq {\n    height: 200px;\n  }\n\n  .chatbotformtitleWix {\n    margin: 0;\n    padding: 12px;\n\n    h4 {\n      margin: 0 0 12px;\n      font-size: 13px;\n      font-family: 'interregular';\n      line-height: 20px;\n    }\n\n    .primarybtn.startbtn {\n      background: #252526 !important;\n      border-color: #252526 !important;\n      margin: 0;\n    }\n  }\n\n  .forminputcol {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    .ant-picker {\n      box-shadow: none;\n      background: #f7f9fc;\n\n      &:hover {\n        border: 1px solid #bdbebf;\n        background: #f7f9fc;\n        box-shadow: none;\n      }\n\n      &.ant-picker-focused {\n        background: #f7f9fc;\n        border: 1px solid #bdbebf;\n        box-shadow: none;\n      }\n    }\n  }\n\n  .chatbotform {\n    margin: 0;\n\n    .ant-form-item {\n      margin: 0 0 4px;\n    }\n  }\n}\n\n.icon_sendarrow {\n  &:before {\n    color: #00b885;\n  }\n}\n\n.icon_attach {\n  color: #757676;\n  font-size: 20px;\n}\n\n/* width */\n.scrollerno::-webkit-scrollbar {\n  width: 4px;\n  border-radius: 3px;\n}\n\n\n.scroller::-webkit-scrollbar {\n  width: 4px;\n  border-radius: 3px;\n}\n\n/* Track */\n.scroller::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 3px;\n}\n\n/* Handle */\n.scroller::-webkit-scrollbar-thumb {\n  background: #d3d6de;\n  border-radius: 3px;\n}\n\n/* Handle on hover */\n.scroller::-webkit-scrollbar-thumb:hover {\n  background: #d3d6de;\n  border-radius: 3px;\n}\n\n.leftmessage {\n  max-width: 100%;\n  //word-break: break-word;\n}\n\n.messagedialogBtn {\n  margin: 0 0 0 36px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n  justify-content: flex-start;\n  //animation: 300ms ease 0.1s 1 normal none running geowJn;\n\n  .dialogBtn {\n    border-radius: 6px;\n    padding: 8px 12px;\n    font-size: 12px;\n    white-space: normal;\n    background-color: #fff;\n    font-family: var(--widgetPreviewFont);\n    text-align: center;\n    line-height: 16px;\n    cursor: pointer;\n    margin: 0;\n    min-width: 80px;\n    border: 1px solid #00b885;\n    color: #00b885;\n    display: inline-block;\n    align-items: center;\n    max-height: 60px;\n    font-family: \"interregular\";\n\n    &.red {\n      border: 1px solid var(--widgetActionMessageColor);\n      color: var(--widgetActionMessageColor);\n    }\n\n    &.green {\n      //color: #00b885;\n      border: 1px solid var(--widgetActionMessageColor);\n      color: var(--widgetActionMessageColor);\n      background: var(--widgetActionMessageColorbg);\n      font-family: 'intermedium';\n      text-transform: capitalize;\n      font-size: 13px;\n    }\n  }\n\n  &:empty {\n    display: none;\n  }\n}\n\n.addressBlock {\n  border-radius: 12px;\n  overflow: hidden;\n  background: #E3E4E5;\n  width: 244px;\n  margin: 8px 0 16px 4px;\n\n  p {\n    margin: 0;\n    padding: 8px 10px;\n  }\n\n  .checkoutBtn {\n    margin: 0;\n\n    label {\n      border-top: 1px solid #fff;\n      color: var(--widgetActionMessageColor);\n      text-align: left;\n      font-size: 14px;\n      line-height: 19px;\n      margin: 0;\n      padding: 10px 7px;\n      cursor: pointer;\n      height: auto;\n      display: inline-flex;\n      align-items: center;\n      gap: 6px;\n      font-family: \"intermedium\";\n      width: 94%;\n    }\n\n    input[type=\"radio\"] {\n      margin: 0px !important;\n    }\n  }\n\n  h5 {\n    border-top: 1px solid #fff;\n    color: var(--widgetActionMessageColor);\n    text-align: center;\n    font-size: 14px;\n    line-height: 20px;\n    margin: 0 -15px;\n    padding: 10px 12px;\n    cursor: pointer;\n  }\n}\n\n.addnewaddresses {\n  border-top: 1px solid #fff;\n  text-align: left;\n  font-size: 14px;\n  line-height: 19px;\n  margin: 0;\n  padding: 10px 7px;\n  cursor: pointer;\n  height: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-family: \"intermedium\";\n  width: 94%;\n\n  input[type=\"radio\"] {\n    margin: 0px !important;\n  }\n}\n\n.addressBlock div {\n  width: 100%;\n  // padding-left: 10px;\n}\n\n.addressBlock button {\n  cursor: pointer;\n}\n\n.addressBlock label {\n  height: 40px;\n  align-items: center;\n  width: 100%;\n  border-top: 1px solid #fff;\n  display: flex;\n  align-items: center;\n\n}\n\n.welcomemessage {\n  width: 100%;\n  border-radius: 8px;\n  background: #fff;\n  display: flex;\n  padding: 6px 12px;\n  align-items: center;\n  box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.15);\n  position: relative;\n  min-height: 36px;\n  max-width: 177px;\n  min-width: 50px;\n  bottom: 2px;\n\n  p {\n    font-size: 12px;\n    color: #000;\n    font-family: \"interregular\";\n    line-height: 16px;\n    margin: 0;\n    max-width: 170px;\n\n    &:first-letter {\n      text-transform: capitalize\n    }\n  }\n\n  img {\n    width: 22px;\n    height: 22px;\n    position: absolute;\n    left: -11px;\n    top: -7px;\n  }\n\n  &::after {\n    content: '';\n    border-bottom: 12px solid #dbdbdbb8;\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    position: absolute;\n    right: -17px;\n    transform: rotate(90deg);\n    bottom: 16px;\n    width: 3px;\n  }\n\n  &::before {\n    content: \"\";\n    border-bottom: 12px solid #ffffff;\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    position: absolute;\n    right: -15px;\n    transform: rotate(90deg);\n    z-index: 9;\n    bottom: 16px;\n    width: 2px;\n  }\n\n  span {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    cursor: pointer;\n    color: #828385;\n    font-family: \"ur_browser_app_rewamp\";\n    font-weight: 100;\n  }\n\n  .welcomeimg {\n    width: 36px;\n    height: 36px;\n    position: absolute;\n    top: -20px;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    background-color: #00b885;\n    border-radius: 50%;\n    padding: 4px;\n    font-size: 14px;\n    line-height: 20px;\n\n    img {\n      border-radius: 50%;\n      width: 100%;\n    }\n  }\n}\n\n.botMsgArea {\n  //width: fit-content;\n\n  .topArea {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    margin: 4px 0;\n    max-width: 84%;\n\n    .botTitle {\n      color: #252526;\n      font-size: 14px;\n      font-family: \"intersemibold\";\n      margin: 0 12px 0 0;\n\n      &::first-letter {\n        text-transform: capitalize;\n      }\n    }\n\n    .likebefore {\n      background-image: url(./images/likegrey.svg);\n      width: 15px;\n      height: 15px;\n      display: inline-flex;\n      margin-right: 2px;\n      background-size: cover;\n      cursor: pointer;\n    }\n\n    .likeafter {\n      background-image: url(./images/likegreen.svg);\n      width: 15px;\n      height: 15px;\n      display: inline-flex;\n      margin-right: 2px;\n      background-size: cover;\n      cursor: pointer;\n    }\n\n    .dislikebefore {\n      background-image: url(./images/dislikegrey.svg);\n      width: 15px;\n      height: 15px;\n      display: inline-flex;\n      background-size: cover;\n      position: relative;\n      top: 1px;\n      cursor: pointer;\n    }\n\n    .dislikeafter {\n      background-image: url(./images/dislikered.svg);\n      width: 15px;\n      height: 15px;\n      display: inline-flex;\n      background-size: cover;\n      position: relative;\n      top: 1px;\n      cursor: pointer;\n    }\n  }\n}\n\n.paymentForm {\n  padding: 10px;\n  border-radius: 8px;\n\n  p {\n    font-family: \"interregular\";\n    color: #555658;\n    font-size: 16px;\n  }\n\n  .inputArea {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    margin-bottom: 6px;\n    font-family: \"interregular\";\n    color: #505152;\n    font-size: 14px;\n\n    label {\n      font-family: \"interregular\";\n      color: #505152;\n      font-size: 14px;\n    }\n\n    input {\n      height: 38px;\n      border-radius: 6px;\n    }\n\n\n  }\n\n  .rowArea {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 12px;\n\n    .smInput {\n      width: 70px;\n    }\n\n    .expiry {\n      display: flex;\n      align-items: center;\n      gap: 20px;\n      margin-bottom: 2px;\n    }\n\n    .cvvInput {\n      width: 100px;\n    }\n\n    input {\n      height: 38px;\n      border-radius: 6px;\n    }\n\n    label {\n      font-family: \"interregular\";\n      color: #505152;\n      font-size: 14px;\n      width: 100px;\n    }\n  }\n\n  .cardDetails {\n    display: flex;\n    align-items: center;\n    font-family: \"interregular\";\n    color: #555658;\n    font-size: 14px;\n    margin: 16px 0px;\n    gap: 40px;\n  }\n\n}\n\n.formchat {\n  .btnSection {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin: 20px 0;\n  }\n\n  a {\n    font-size: 12px;\n  }\n\n  .btnCancel {\n    border-radius: 6px;\n    padding: 8px 16px;\n    font-size: 14px;\n    font-weight: 500;\n    text-align: center;\n    line-height: 16px;\n    cursor: pointer;\n    min-width: 80px;\n    max-width: 195px;\n    font-family: \"intersemibold\";\n    color: #252526;\n    border: 1px solid #D2D3D4;\n    background: #FFF;\n\n    &:hover {\n      outline: 1px solid;\n    }\n  }\n\n  .btnGreen {\n    border-radius: 6px;\n    padding: 8px 16px;\n    font-size: 14px;\n    background-color: #00b885;\n    font-weight: 500;\n    text-align: center;\n    line-height: 16px;\n    cursor: pointer;\n    min-width: 80px;\n    max-width: 195px;\n    color: #fff;\n    font-family: 'intersemibold';\n    border-color: #00b885;\n\n    &:hover {\n      background-color: #00E2A4;\n    }\n  }\n}\n\n.chatbottomview {\n\n  position: relative;\n\n  .conrfirmSection {\n    position: absolute;\n    border-radius: 12px;\n    background: #fff;\n    width: 75%;\n    margin: 0px auto;\n    top: 5%;\n    padding: 16px;\n    text-align: center;\n    left: 26px;\n    border: 1px solid #E3E4E5;\n    box-shadow: 0px 19px 25px -13px rgba(0, 0, 0, 0.2509803922);\n\n    p {\n      color: #252526;\n      font-size: 16px;\n      font-family: 'intersemibold';\n      margin-top: 0px;\n      margin-bottom: 10px;\n      line-height: 20px;\n    }\n\n    .btnSection {\n      .btnGreen {\n        background: #252526 !important;\n        border-color: #252526 !important;\n      }\n    }\n  }\n\n  .btnCancel {\n    border-radius: 6px;\n    padding: 8px 4px;\n    font-size: 14px;\n    font-weight: 500;\n    text-align: center;\n    line-height: 16px;\n    cursor: pointer;\n    margin: 5px;\n    min-width: 80px;\n    max-width: 195px;\n    font-family: \"intersemibold\";\n    color: #252526;\n    border: 1px solid #D2D3D4;\n    background: #FFF;\n\n    &:hover {\n      outline: 1px solid;\n    }\n  }\n\n  .btnGreen {\n    border-radius: 6px;\n    padding: 8px 4px;\n    font-size: 14px;\n    background-color: #00b885;\n    font-weight: 500;\n    text-align: center;\n    line-height: 16px;\n    cursor: pointer;\n    margin: 5px;\n    min-width: 80px;\n    max-width: 195px;\n    color: #fff;\n    font-family: 'intersemibold';\n\n    &:hover {\n      background-color: #00E2A4;\n    }\n  }\n}\n\n.mandatory {\n  color: #EB3F67;\n}\n\n.ant-modal.loginpagepopup {\n  width: 964px !important;\n\n  .ant-modal-footer {\n    display: none;\n  }\n\n  .ant-modal-header {\n    display: none;\n  }\n\n  .ant-modal-body {\n    padding: 0;\n    background: #fff;\n    float: left;\n    border-radius: 10px;\n  }\n\n  .anticon-close {\n    background: url(./images/close.svg);\n    width: 22px;\n    height: 22px;\n\n    svg {\n      display: none;\n    }\n  }\n}\n\n\n.p-PaymentDetails-group {\n  position: relative;\n}\n\n.chatbottomview {\n  button {\n    border: 1px solid transparent;\n    padding: 6px 12px;\n    font-size: 14px;\n    line-height: 1.42857143;\n    border-radius: 4px;\n    color: #fff;\n    background-color: #5cb85c;\n    border-color: #4cae4c;\n    margin-bottom: 0rem;\n    margin-top: 0.5rem;\n  }\n}\n\n.paypalview {\n  width: 100%;\n  max-width: 100%;\n  position: absolute;\n  top: 10px;\n  margin: 0;\n  height: 350px;\n  border: none;\n}\n\n.paymentscroll {\n  overflow-y: overlay;\n  height: calc(100vh - 0px);\n  padding: 0 16px;\n}\n\n.braintree-option {\n  border-color: #E3E4E5;\n}\n\n.braintree-placeholder {\n  display: none;\n}\n\n.braintree-option .braintree-option__label {\n  color: #828385;\n  font-family: \"interregular\";\n}\n\n.braintree-option:hover .braintree-option__label {\n  color: #828385;\n  font-weight: 400;\n  font-family: \"interregular\";\n}\n\n.braintree-sheet {\n  border: 1px solid #E3E4E5;\n  padding: 12px;\n}\n\n.braintree-sheet__header {\n  border-bottom: 1px solid #E3E4E5;\n}\n\n.braintree-sheet__content--form .braintree-form__field-group .braintree-form__field .braintree-form__hosted-field {\n  border: 1px solid #E3E4E5;\n  border-radius: 6px;\n}\n\n.braintree-sheet__content--form .braintree-form__field-group .braintree-form__label {\n  color: #828385;\n  font-family: \"interregular\";\n}\n\n.braintreePayButton {\n  width: 100%;\n  border: 1px solid #00b885;\n  background-color: #00b885;\n  color: #ffffff;\n  padding: 12px;\n  margin: 30px auto 16px;\n  height: 40px;\n  line-height: 15px;\n  font-size: 16px;\n\n  &:hover {\n    border: 1px solid #00b885;\n    background-color: #00b885 !important;\n  }\n}\n\n.braintree-large-button {\n  background: transparent;\n  border-color: #000000;\n}\n\n.braintree-large-button:hover {\n  font-size: 14px;\n  font-weight: 400;\n  background: transparent;\n  border-color: #000000;\n}\n\n.braintree-form__notice-of-collection {\n  a {\n    color: #575CFF;\n    font-size: 14px;\n    text-decoration: none;\n    font-family: \"interregular\";\n  }\n}\n\n.braintree-sheet__content--form .braintree-form__field-group .braintree-form__field-error {\n  font-family: \"interregular\";\n  font-size: 12px;\n}\n\n.braintree-sheet--has-error .braintree-sheet__error .braintree-sheet__error-text {\n  font-family: \"interregular\";\n  font-size: 12px;\n}\n\n/////////////\n\n/*----------------- MAIN CONTAINER -----------------*/\n\n\n/*SET NEW FONT*/\n@import 'https://fonts.googleapis.com/css?family=Abel';\n\n/*\n@import 'https://fonts.googleapis.com/css?family=Poiret+One';\n*/\n/* to expand the width to full width or any other size. max-width: 100%;*/\n#rxp-hpp {\n  background: #ffffff;\n  font-family: 'Abel', sans-serif;\n}\n\n#another-card-section {\n  background: #f9f9f9;\n  padding-top: 20px;\n}\n\n#another-card-section .panel-title,\n#saved-card-section .panel-title {\n  color: #990033;\n}\n\n.panel-group .panel {\n  border-radius: 0px;\n}\n\n/*----------------- HEADER -----------------*/\n\n#rxp-header {\n  margin-bottom: 0px;\n}\n\n#rxp-header-title {\n  background: transparent;\n  color: #990033;\n  padding: 20px 30px 0px 0px;\n  font-size: 1.5em;\n}\n\n/*----------------- FORM -----------------*/\n.panel {\n  border-color: #ffffff;\n}\n\n#rpx-another-card {\n  margin-top: 30px;\n}\n\n#rpx-cardnum-section .form-group {\n  display: flex;\n  width: 100%;\n}\n\n/* This is to change the look and size of the labels */\n#rpx-another-card .control-label {\n  font-family: 'Abel', sans-serif;\n  margin-top: 15px;\n}\n\n/* This is to change the look and size of the input */\n#rpx-another-card .form-control {\n  border: 0px;\n  height: 50px;\n  background-color: #dddddd;\n  font-family: 'Abel', sans-serif;\n  border-radius: 0px;\n}\n\n#rpx-another-card .has-error .form-control {\n  background-color: #ffcccc;\n}\n\n.input-group-addon {\n  background-color: #990033;\n  border: 0px solid #9900cc;\n  color: #ffffff;\n}\n\n/* the following are to allow the label on the left and the input on the right */\n#rpx-cardnum-section {\n  position: relative;\n}\n\n#rpx-cardnum-title {\n  width: 50%;\n}\n\n#rpx-cardnum-item {\n  position: absolute;\n  top: -25px;\n  right: 0px;\n}\n\n#rpx-expiry-date {\n  margin-bottom: 10px\n}\n\n#rpx-expiry-date .col-xs-5 {\n  width: 20%;\n}\n\n#rpx-expiry-date .slash {\n  width: 10%;\n  margin-top: 10px;\n}\n\n#rpx-expiry-date,\n#rpx-security-code {\n  width: 100%;\n}\n\n#rpx-date-cccvc-section .form-group .col-xs-12,\n#rpx-cardholder-section .form-group .col-xs-12 {\n  width: 50%;\n}\n\n#rpx-cardnum-title,\n#rpx-cardnum-item {\n  width: 50%;\n}\n\n#rpx-cardnum-box {\n  width: 50%;\n}\n\n\n/*----------------- DCC -----------------*/\n.btn-dcc.active {\n  border-bottom: 2px solid #990033;\n}\n\n.rxp-dcc-offer-legal {\n  font-size: .7em;\n}\n\n.panel-dcc .panel-body .rxp-title {\n  font-size: 1.2em;\n  color: #990033;\n}\n\n.dcc-title-box {\n  line-height: 1.1em;\n}\n\n/*----------------- CARD MANAGEMENT -----------------*/\n#rpx-saved-card .control-label,\n#rpx-another-card .control-label {\n  font-family: 'Abel', sans-serif;\n}\n\n#rpx-saved-card .panel-saved-card:hover {\n  border-top: 1px solid #990033;\n  border-bottom: 1px solid #990033;\n}\n\n\n/*----------------- BUTTON -----------------*/\n/* this is the actual button */\n#main-btn-box .btn-hpp-a {\n  font-size: 1.25em;\n  background-color: #990033;\n  font-weight: 100;\n  margin-bottom: 20px;\n  box-shadow: 1px 2px 6px #cbcbcb;\n\n}\n\n\n/*----------------- FOOTER -----------------*/\n/* this is for the entire footer */\n#rxp-footer {\n  display: none;\n}\n\n.cardpaybtn {\n  width: 100%;\n  margin: 10px 0 16px;\n  border: none;\n  border-radius: 6px;\n  padding: 12px 12px;\n  color: #ffffff;\n  cursor: pointer;\n}\n\n\n.fc-frame {\n  min-height: 73px;\n  min-width: 65px;\n  overflow: hidden;\n  position: fixed;\n  right: 15px;\n  z-index: 2147483600;\n}\n\n$dot-width: 8px;\n$dot-color: #00b885;\n$speed: 1.5s;\n\n.typing {\n  position: relative;\n  top: -20px;\n  left: -8px;\n\n  span {\n    content: '';\n    animation: blink $speed infinite;\n    animation-fill-mode: both;\n    height: $dot-width;\n    width: $dot-width;\n    background: $dot-color;\n    position: absolute;\n    left: 0;\n    top: 0;\n    border-radius: 50%;\n\n    &:nth-child(2) {\n      animation-delay: .2s;\n      margin-left: $dot-width * 1.5;\n    }\n\n    &:nth-child(3) {\n      animation-delay: .4s;\n      margin-left: $dot-width * 3;\n    }\n  }\n}\n\n\n@keyframes blink {\n  0% {\n    opacity: .1;\n  }\n\n  20% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: .1;\n  }\n}\n\n.lottie {\n  position: relative;\n  top: 0px;\n}\n\n.lottiebot {\n  display: flex;\n  align-items: center;\n  background: transparent !important;\n  padding: 0 !important;\n  font-style: italic;\n  text-transform: lowercase;\n  margin: 0 !important;\n  position: relative;\n  top: -4px;\n\n  .sendmailagent {\n    margin: 0 !important;\n  }\n}\n\n\n.endchats {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  left: 0;\n  height: 100%;\n  border-radius: var(--widgetBorderRadius);\n  background: rgba(0, 0, 0, 0.4509803922);\n  z-index: 99;\n\n  .endchatsinner {\n    background: #F0F1F2;\n    bottom: 0;\n    position: absolute;\n    width: 100%;\n    border-radius: 12px 12px var(--widgetBorderRadius) var(--widgetBorderRadius);\n    padding: 0 0 8px;\n  }\n\n  h3 {\n    color: #252526;\n    font-size: 18px;\n    font-family: \"intersemibold\";\n    line-height: 25px;\n    letter-spacing: -0.4px;\n    margin: 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px;\n\n    svg {\n      cursor: pointer;\n    }\n  }\n\n  .endchatslist {\n    margin: 0 16px;\n    background: #fff;\n    border-radius: 12px;\n\n    p {\n      border-bottom: 1px solid #D2D3D4;\n      padding: 14px 16px 14px 0;\n      color: #252526;\n      font-family: \"intermedium\";\n      font-size: 14px;\n      line-height: 18px;\n      display: flex;\n      gap: 12px;\n      align-items: center;\n      margin: 0 0 0 16px;\n      cursor: pointer;\n\n      &:nth-last-child(1) {\n        border: none;\n      }\n\n      svg {\n        height: 14px;\n\n      }\n    }\n  }\n\n  .endlanguages {\n    background: #fff;\n    box-shadow: 0px 6px 8px 0px rgba(12, 21, 35, 0.18);\n    width: calc(100% - 1px);\n    left: 0.4px;\n    bottom: 0.4px;\n    overflow: hidden;\n  }\n\n  .endchatli {\n    ul {\n      margin: 0;\n      padding: 0;\n\n      li {\n        color: #252526;\n        font-family: \"intermedium\";\n        font-size: 14px;\n        line-height: 18px;\n        padding: 12px 16px;\n        cursor: pointer;\n\n        &:hover {\n          background: #DCF5EE;\n\n        }\n      }\n    }\n  }\n\n  .enchatsinputmain {\n    margin: 0 16px;\n\n    input {\n      border-radius: 10px;\n      border: 1px solid #D2D3D4;\n      background: #FFF;\n      box-shadow: 0px 2px 3px 0px rgba(12, 21, 35, 0.04);\n      display: flex;\n      width: auto;\n      height: 48px;\n      padding: 0 12px;\n      align-items: center;\n      color: #828385;\n      font-family: 'intermedium';\n      font-size: 16px;\n      line-height: 18px;\n      width: 92%;\n    }\n  }\n\n  .endchatsbtn {\n    border-radius: 6px;\n    background: #DE003D;\n    color: #fff;\n    text-align: center;\n    font-family: \"intersemibold\";\n    font-size: 14px;\n    max-height: 38px;\n    display: flex;\n    padding: 6px 12px;\n    justify-content: center;\n    align-items: center;\n    margin: 16px;\n    cursor: pointer;\n\n    &.endchatsgreen {\n      background: #00B885;\n    }\n  }\n}\n\n.worktualmobileBrowser {\n  .chatbotlayout {\n    width: 100%;\n    height: 100vh;\n    bottom: 0;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n\n  /*   .chatPreview {\n    display: none;\n  } */\n\n  .chatPreviewMobileHide {\n    visibility: hidden;\n  }\n\n  .chatPreviewMobileVisible {\n    visibility: visible;\n  }\n\n  .chatbottomview {\n    height: calc(100vh - 192px);\n    max-height: 100vh;\n  }\n\n  .endchatsinner {\n    border-radius: 12px 12px 0 0;\n  }\n\n  .chatinfo {\n    border-radius: 0;\n  }\n\n  .chatHeader {\n    border-radius: 0;\n  }\n\n  .chatbotformtitle {\n    height: calc(100vh - 128px);\n    max-height: 100vh;\n  }\n\n  .chatBody {\n    border-radius: 0;\n  }\n}\n\n.ant-checkbox-group {\n  display: grid;\n  align-items: center;\n  gap: 2px;\n}\n\n.groupchattitle {\n  color: #252526 !important;\n  font-size: 14px !important;\n  line-height: normal !important;\n  background: transparent !important;\n  font-family: 'intermedium';\n  padding: 10px 0 !important;\n  display: block !important;\n}\n\ntextarea#Sdfgsdgsdgsd::placeholder {\n  color: #828385;\n}\n\n.ant-form-item-explain {\n  padding-top: 2px;\n}\n\n\n.ant-radio {\n  &.ant-radio-checked {\n    .ant-radio-inner {\n      border-color: #fff;\n\n      &:after {\n        background-color: var(--dynamicprimaryButtonBg);\n        width: 28px;\n        height: 28px;\n        margin-top: -14px;\n        margin-left: -14px;\n      }\n    }\n  }\n}\n\n.ant-radio-wrapper:hover :where(.css-dev-only-do-not-override-6j9yrn).ant-radio-wrapper,\n:where(.css-dev-only-do-not-override-6j9yrn).ant-radio-wrapper:hover .ant-radio-inner,\n:where(.css-dev-only-do-not-override-6j9yrn).ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner,\n:where(.css-dev-only-do-not-override-6j9yrn).ant-checkbox:not(.ant-checkbox-disabled):hover .ant-checkbox-inner {\n  border-color: var(--dynamicprimaryButtonBg) !important;\n}\n\n:where(.css-dev-only-do-not-override-6j9yrn).ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {\n  background: var(--dynamicprimaryButtonBg) !important;\n}\n\n.ant-radio.ant-radio-checked .ant-radio-inner {\n  background-color: #fff;\n  //border-color: #00b885;\n}\n\n.ant-checkbox .ant-checkbox-inner {\n  height: 18px;\n  width: 18px;\n}\n\nspan.ant-radio span.ant-radio-inner {\n  height: 18px;\n  width: 18px;\n\n  &:hover {\n    border-color: #00b885;\n  }\n\n}\n\n.ant-checkbox.ant-checkbox-checked .ant-checkbox-inner {\n  background-color: var(--dynamicprimaryButtonBg);\n  border: 1px solid var(--dynamicprimaryButtonBg);\n  border-radius: 4px;\n  box-shadow: 0 1px 2px 0 #00000014;\n}\n\n:where(.css-dev-only-do-not-override-2q8sxy).ant-input:focus,\n:where(.css-dev-only-do-not-override-2q8sxy).ant-input:focus-within {\n  box-shadow: none !important;\n}\n\n.emailinputs {\n  display: grid !important;\n  gap: 6px !important;\n\n  span {\n    font-size: 12px;\n    color: #DE003D;\n  }\n}\n\n.chatmsgbox {\n  width: 100%;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.chatleftview {\n  .sendmailagent {\n    display: none;\n  }\n\n  &:hover {\n    .sendmailagent {\n      display: block;\n    }\n  }\n}\n\n.chatrightview {\n  .sendmail {\n    display: none;\n  }\n\n  &:hover {\n    .sendmail {\n      display: block;\n    }\n  }\n}\n\n.radiobtn {\n  width: 100%;\n\n  .radioblock {\n    display: grid;\n    align-items: center;\n    gap: 2px;\n\n    label {\n      background: #F0F1F2;\n      padding: 10px;\n      color: #252526;\n      font-family: \"intermedium\";\n      font-size: 14px;\n      line-height: 0;\n      display: flex;\n      align-items: center;\n\n      &:nth-child(1) {\n        border-radius: 6px 6px 0 0;\n      }\n\n      &:nth-last-child(1) {\n        border-radius: 0 0 6px 6px;\n      }\n    }\n  }\n}\n\n@keyframes fadeInIcon {\n  99% {\n    visibility: hidden;\n  }\n\n  100% {\n    visibility: visible;\n  }\n}\n\n.worktualcalendar {\n  border-top: 1px solid #D2D3D4;\n  border-bottom: 1px solid #D2D3D4;\n  margin: 12px 0;\n  padding: 12px 0;\n\n  .worktualcalendartop {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    margin: 0 0 12px;\n\n    p {\n      font-family: 'intermedium' !important;\n      line-height: normal;\n      display: flex;\n      align-items: center;\n      gap: 6px;\n    }\n  }\n\n  .worktualcalendarweeks {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 6px;\n\n    p {\n      width: 10%;\n      border-radius: 6px;\n      min-width: 24px;\n      min-height: 24px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-family: \"intermedium\" !important;\n      margin: 4px 0 !important;\n      border: 1px solid var(--widgetChatMessageColor);\n      cursor: pointer !important;\n\n      &:hover {\n        border: 1px solid var(--dynamicAgentMessageTextColor);\n\n      }\n    }\n\n    &.worktualsu {\n      p {\n        font-family: \"interlight\" !important;\n        pointer-events: none;\n      }\n    }\n  }\n}\n\np.worktualbtns {\n  color: var(--widgetActionMessageColor) !important;\n  font-family: \"intersemibold\" !important;\n  text-align: center;\n  margin: 0 auto 4px !important;\n  display: table;\n  cursor: pointer;\n}\n\np.worktualdisable {\n  opacity: 0.3;\n\n  &:hover {\n    border-color: transparent !important;\n  }\n}\n\n.worktualmonths {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 12px 0;\n\n  p {\n    width: 33%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: 'intermedium' !important;\n    margin: 8px 0 !important;\n    opacity: 0.5;\n    cursor: pointer;\n\n    &.active {\n      opacity: 1;\n    }\n  }\n}\n\n.worktualtimer {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  justify-content: center;\n  background: var(--widgetChatMessageColor);\n  padding: 24px 16px;\n  border-top: 0.1px solid var(--dynamicAgentMessageTextColor);\n  margin: 12px 0;\n  border-bottom: 0.1px solid var(--dynamicAgentMessageTextColor);\n  border-radius: 0;\n\n  svg {\n    width: 24px;\n    cursor: pointer;\n  }\n\n  .worktualtimerinner {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    align-items: center;\n    justify-content: center;\n\n    p {\n      width: 42%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-family: \"intermedium\" !important;\n      border: 0.2px solid var(--dynamicAgentMessageTextColor);\n      border-radius: 6px;\n      cursor: pointer;\n      padding: 4px;\n      margin: 0;\n\n      &:hover {\n        background: var(--widgetChatCustomerMessageColor);\n      }\n\n      &.activewk {\n        background: var(--widgetChatCustomerMessageColor);\n      }\n    }\n  }\n}\n\n.ant-picker-cell-inner.ant-picker-calendar-date {\n  padding: 0 !important;\n  height: 24px !important;\n}\n\n.ant-radio-group.ant-radio-group-outline.ant-picker-calendar-mode-switch {\n  display: none;\n}\n\n.ant-picker-calendar-header {\n  justify-content: center !important;\n  align-items: center;\n  padding: 0 0 6px !important;\n}\n\n.ant-select-selector {\n  background: transparent !important;\n  border: 0 !important;\n\n}\n\nspan.ant-select-arrow {\n  background: url(./images/arrowbottom.png) no-repeat;\n  background-size: 10px;\n  background-position: center;\n  width: 16px;\n  right: 6px !important;\n  height: 16px !important;\n  margin: -7px 0 0 !important;\n\n  span {\n    display: none;\n  }\n}\n\ntable.ant-picker-content {\n  th {\n    font-family: \"interlight\" !important;\n    font-size: 14px !important;\n    color: var(--dynamicAgentMessageTextColor) !important;\n    height: 24px !important;\n    width: 24px !important;\n    padding: 0 0 10px !important;\n    text-align: center;\n  }\n\n  td {\n    font-family: \"intermedium\" !important;\n    font-size: 14px !important;\n    color: var(--dynamicAgentMessageTextColor) !important;\n  }\n}\n\n.ant-picker-calendar-date-value {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ant-picker-cell-inner.ant-picker-calendar-date {\n  border: 0 !important;\n  margin: 4px auto !important;\n  border-radius: 6px !important;\n  height: 24px !important;\n  width: 24px !important;\n}\n\nspan.ant-select-selection-item {\n  color: var(--dynamicAgentMessageTextColor) !important;\n  font-family: 'intermedium' !important;\n}\n\n.ant-select-focused:where(.css-dev-only-do-not-override-2q8sxy).ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {\n  box-shadow: none !important;\n}\n\n.rc-virtual-list-scrollbar.rc-virtual-list-scrollbar-vertical {\n  width: 3px !important;\n}\n\n.ant-picker-calendar.ant-picker-calendar-full,\n.ant-picker-panel {\n  background: var(--widgetChatMessageColor) !important;\n}\n\n.worktualmaincalendar {\n  border-radius: 12px;\n  background: var(--widgetChatMessageColor);\n  padding: 12px 0;\n\n  p {\n    margin: 0;\n    padding: 0 16px;\n  }\n}\n\n.ant-picker-calendar.ant-picker-calendar-full {\n  border-top: 0.1px solid var(--dynamicAgentMessageTextColor);\n  padding: 12px 16px;\n  margin: 12px 0;\n  border-bottom: 0.1px solid var(--dynamicAgentMessageTextColor);\n}\n\ntd.ant-picker-cell.ant-picker-cell-in-view.ant-picker-cell-selected {\n  .ant-picker-cell-inner.ant-picker-calendar-date {\n    background: var(--widgetChatCustomerMessageColor) !important;\n\n    .ant-picker-calendar-date-value {\n      color: var(--dynamictextHeader) !important;\n      outline: 1px solid var(--dynamicAgentMessageTextColor) !important;\n      border-radius: 6px;\n    }\n  }\n}\n\n:where(.css-dev-only-do-not-override-2q8sxy).ant-select-dropdown {\n  box-shadow: 0px 2px 3px 0px rgb(12 21 35 / 23%);\n  background: #fff;\n  padding: 4px 0;\n}\n\n.ant-select-item.ant-select-item-option {\n  &.ant-select-item-option-active {\n    background: #f4f4f4;\n  }\n\n  &:hover {\n    background: #f4f4f4;\n  }\n}\n\n.ant-picker-calendar-date-content {\n  display: none;\n}\n\ntd.ant-picker-cell {\n  opacity: 0.4;\n  cursor: pointer;\n}\n\ntd.ant-picker-cell.ant-picker-cell-in-view,\ntd.ant-picker-cell.ant-picker-cell-end.ant-picker-cell-in-view {\n  opacity: 1;\n}\n\ntd.ant-picker-cell.ant-picker-cell-disabled.ant-picker-cell-in-view {\n  pointer-events: none;\n\n  opacity: 0.4;\n}\n\n.worktualcarosuelmain {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  width: 336px;\n\n  svg {\n    min-width: 36px;\n    min-height: 36px;\n    cursor: pointer;\n    position: absolute;\n    z-index: 99;\n    top: 52px;\n\n    &:nth-child(1) {\n      left: 10px;\n    }\n\n    &:nth-last-child(1) {\n      right: 0;\n    }\n\n    &.disable {\n      opacity: 0;\n      pointer-events: none;\n    }\n  }\n\n  .worktualcarosuelblock {\n    border-radius: 12px;\n    overflow: hidden;\n    background: var(--widgetChatMessageColor);\n    width: 260px;\n    transition: 2s ease;\n    //animation: 300ms ease 0.1s 1 normal none running geowJnside;\n\n    .worktualcarosuelimages {\n      height: 146px;\n      width: 100%;\n      overflow: hidden;\n      margin: 0 0 16px;\n\n      img {\n        width: 100% !important;\n        height: 100%;\n        object-fit: contain;\n        background: var(--widgetChatMessageColor);\n      }\n    }\n\n    p {\n      color: var(--dynamicAgentMessageTextColor);\n      font-size: 12px;\n      font-family: 'interlight';\n      line-height: 17px;\n      margin: 0;\n      padding: 0 12px;\n      overflow: hidden;\n      width: 90%;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n    }\n\n    h3 {\n      color: var(--dynamicAgentMessageTextColor);\n      font-family: \"intersemibold\";\n      font-size: 14px;\n      line-height: 20px;\n      margin: 8px 0 6px;\n      padding: 0 12px;\n      //text-transform: capitalize;\n\n      &.worktualpricing {\n        font-family: 'interbold';\n        font-size: 15px;\n      }\n    }\n\n    h4 {\n      color: var(--widgetActionMessageColor);\n      font-size: 12px;\n      font-family: 'interlight';\n      line-height: 18px;\n      margin: 0 0 8px;\n      padding: 0 12px;\n    }\n\n    .btns {\n      h5 {\n        border-top: 1px solid #fff;\n        color: var(--widgetActionMessageColor);\n        text-align: center;\n        font-family: 'intersemibold';\n        font-size: 14px;\n        line-height: 20px;\n        margin: 0;\n        padding: 12px 0;\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n.forfiles {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n\n  img {\n    width: 46px !important;\n\n    &.imagenotforfiles {\n      width: 100% !important;\n    }\n  }\n}\n\n.articlebox {\n  margin: -8px;\n  display: block;\n  text-align: center;\n  min-width: 190px;\n\n  p {\n    padding: 10px;\n    text-align: left;\n  }\n\n  .articlemsgs {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-top: 1px solid var(--border-line, #D2D3D4);\n    padding: 10px;\n\n    p {\n      padding: 0 !important;\n    }\n  }\n}\n\n.articleexpand {\n  position: absolute;\n  background: #fff;\n  z-index: 99;\n  width: calc(100% - 32px);\n  height: 100%;\n  top: 0;\n  left: 0;\n  padding: 0 16px;\n  overflow-y: scroll;\n\n  &::-webkit-scrollbar {\n    width: 4px;\n    border-radius: 3px;\n  }\n\n  /* Track */\n  &::-webkit-scrollbar-track {\n    background: transparent;\n    border-radius: 3px;\n  }\n\n  /* Handle */\n  &::-webkit-scrollbar-thumb {\n    background: #d3d6de;\n    border-radius: 3px;\n  }\n\n  /* Handle on hover */\n  &::-webkit-scrollbar-thumb:hover {\n    background: #d3d6de;\n    border-radius: 3px;\n  }\n\n  h4 {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    svg {\n      cursor: pointer;\n    }\n  }\n\n  p {\n    padding: 0 0 0 18px;\n  }\n}\n\n.fordropdowns {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  background: #fff;\n  border: 0.5px solid #000;\n  border-radius: 6px;\n  margin: 4px 0 0;\n\n  span.ant-select-selection-placeholder {\n    color: #000;\n  }\n}\n\n\n.worktualnamelists {\n  width: 100%;\n  display: block;\n  margin: 12px 0 2px;\n}\n\n.checkoutBtn {\n  margin: 12px -10px 0;\n\n  .checkoutProperties {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  .checkoutImg {\n    width: 40px;\n    height: 40px;\n  }\n\n  .checkoutTitle {\n    display: flex;\n    flex-direction: column;\n  }\n\n  h5 {\n    border-top: 1px solid #fff;\n    color: var(--widgetActionMessageColor);\n    text-align: center;\n    font-size: 14px;\n    line-height: 20px;\n    margin: 0 -15px;\n    padding: 10px 12px;\n    cursor: pointer;\n  }\n}\n\n.variantsColour {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 12px;\n  margin: 4px 0 8px;\n  width: 100%;\n\n  .variantsChild {\n    width: 24px;\n    height: 18px;\n    border: 1px solid var(--widgetChatMessageColor);\n    display: flex;\n    padding: 1px;\n    border-radius: 4px;\n    cursor: pointer;\n\n    p {\n      margin: 0;\n      padding: 0;\n      width: 100%;\n      height: 100%;\n      border-radius: 4px;\n    }\n  }\n}\n\n.variationsworktual {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 8px 12px 16px 12px;\n\n  .fordropdowns {\n    margin: 0;\n    width: calc(100% - 104px);\n  }\n\n  .worktualcounters {\n    width: 90px;\n  }\n\n\n}\n\n.worktualcounters {\n  display: flex;\n  align-items: center;\n  border: 0.5px solid;\n  justify-content: space-between;\n  border-radius: 6px;\n  height: 30px;\n  background: #fff;\n\n  .worktualcountersnumber {\n    cursor: pointer;\n    font-size: 20px;\n    padding: 0 8px;\n    display: flex;\n    align-items: center;\n    align-content: center;\n\n    svg {\n      position: unset;\n      min-width: auto;\n      min-height: auto;\n    }\n  }\n\n  input {\n    width: 30px;\n    height: 28px;\n    border: 0;\n    appearance: none;\n    text-align: center;\n    appearance: none;\n    font-size: 14px;\n    font-family: 'intermedium';\n\n    &:focus-visible {\n      border: 0;\n      box-shadow: none;\n      outline: 0;\n    }\n  }\n}\n\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.content-wrapper {\n  display: flex;\n  overflow-x: scroll;\n  gap: 16px;\n  padding: 0 38px;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    height: 0;\n    width: 0;\n  }\n}\n\n@keyframes geowJn {\n  0% {\n    opacity: 0;\n    transform: translateY(32px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n}\n\n@keyframes geowJnside {\n  0% {\n    opacity: 0;\n    transform: translateX(32px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n}\n\n.worktualshopping {\n  margin: 8px 0 0;\n\n  .worktualshoppingproperties {\n    border-radius: 8px;\n    border: 1px solid #D2D3D4;\n    background: #FFF;\n    gap: 8px;\n    padding: 6px;\n    width: 210px;\n    margin: 0 0 8px;\n\n    &:nth-last-child(1) {\n      margin-bottom: 12px;\n    }\n\n    .checkoutImg {\n      border-radius: 4px;\n      overflow: hidden;\n      height: 50px;\n      background: #f4f4f4;\n      display: flex;\n      align-items: center;\n\n      img {\n        object-fit: contain !important;\n        height: auto !important;\n        width: 100%;\n      }\n    }\n\n    .shopleftworktual {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      width: calc(100% - 76px);\n\n      .worktualcounters {\n        width: 76px;\n        height: 24px;\n        margin: 4px 0 0;\n        justify-content: space-evenly;\n\n        input {\n          height: 22px;\n          margin: 0;\n          width: 20px;\n        }\n      }\n\n      .worktualcountersnumber {\n        padding: 0 6px;\n      }\n    }\n\n    .checkoutTitle {\n      width: calc(100% - 50px);\n\n      p {\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        overflow: hidden;\n        font-family: 'intersemibold' !important;\n      }\n    }\n\n    .worktualshoppricelists {\n      display: grid;\n      justify-items: end;\n      align-content: space-around;\n      width: 140px;\n\n      .worktualshopprice {\n        font-family: 'intersemibold' !important;\n      }\n\n      .worktualshoppricediscount {\n        font-family: 'interregular' !important;\n        color: #DE003D !important;\n        text-decoration: line-through;\n      }\n    }\n  }\n}\n\n.reswork {\n  h5 {\n    display: grid;\n    justify-items: center;\n\n    span {\n      font-size: 12px;\n      font-family: 'interlight';\n    }\n  }\n}\n\n.worktualwix {\n  padding: 0 16px;\n\n  input {\n    border-radius: 6px;\n    border: 1px solid var(--true-black-300, #D2D3D4);\n    background: var(--Color-Black-White, #FFF);\n    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.04);\n    height: 38px;\n    width: calc(100% - 24px);\n    color: #252526;\n    padding: 0 12px;\n\n    &:focus-visible {\n      outline: 0;\n    }\n  }\n\n  label {\n    color: #828385;\n    font-family: \"interregular\";\n    font-size: 14px;\n    line-height: normal;\n    padding: 16px 0 4px;\n    width: 100%;\n    display: block;\n  }\n\n  &.worktualwixdivide {\n    display: inline-flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 0 16px;\n\n    .worktualwixhalf {\n      width: 50%;\n    }\n\n    span {\n      color: #828385;\n    }\n  }\n\n  .worktualexpires {\n    display: flex;\n    align-items: center;\n    border-radius: 6px;\n    border: 1px solid var(--true-black-300, #D2D3D4);\n    background: var(--Color-Black-White, #FFF);\n    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.04);\n    overflow: hidden;\n    height: 38px;\n\n    input {\n      border: 0;\n      box-shadow: none;\n      border-radius: 0;\n      height: 36px;\n      padding: 0 8px;\n\n      &:nth-child(1) {\n        text-align: right;\n        width: 24px;\n      }\n    }\n  }\n\n  button {\n    border-radius: 6px;\n    background: var(--true-black-800, #252526);\n    display: flex;\n    padding: 9px 18px;\n    justify-content: center;\n    align-items: center;\n    font-family: 'intersemibold';\n    width: 100%;\n    border: 0;\n    color: #fff;\n    font-size: 14px;\n    height: 40px;\n    margin: 25px 0 0;\n  }\n\n  .worktualicondivide {\n    position: relative;\n\n    svg {\n      position: absolute;\n      right: 12px;\n      top: 12px;\n    }\n  }\n}\n\n\niframe {\n  border: 0;\n}\n\n.footertopspace {\n  padding: 7px 12px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: -14px 0 0;\n\n  .footercopys {\n    white-space: nowrap;\n    margin: 0;\n\n    p {\n      border: 0;\n      padding: 0;\n      font-size: 10px;\n    }\n  }\n\n  p {\n    margin: 0;\n    color: #757676;\n    font-size: 8px;\n    font-family: \"interregular\";\n    line-height: 14px;\n    text-align: left;\n    border-left: 1px solid #d4d3d2;\n    padding-left: 12px;\n  }\n}\n\nimg.pdfFiledoc,\nimg.lftFiledoc {\n  min-width: 42px;\n  min-height: 42px;\n  object-fit: fill;\n  width: 42px !important;\n  height: 42px !important;\n}\n\nimg.imgFiledoc {\n  width: 100%;\n  border-radius: 4px;\n}\n\n.worktualattachs {\n  border-radius: 6px;\n  border: 1px dashed #505152;\n  padding: 12px 18px;\n  display: flex;\n  cursor: pointer;\n  width: max-content;\n\n  [type=\"file\"] {\n    height: 0;\n    overflow: hidden;\n    width: 0;\n  }\n\n  [type=\"file\"]+label {\n    display: flex;\n    position: relative;\n    transition: all 0.3s;\n    vertical-align: middle;\n    align-items: center;\n    gap: 12px;\n\n  }\n\n  label {\n    span {\n      color: #575CFF;\n      display: grid;\n      font-size: 12px;\n      line-height: 18px;\n\n      span {\n        color: #252526;\n      }\n    }\n  }\n}\n\n.newecomm {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.mics {\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px;\n  cursor: pointer;\n  position: relative;\n\n  &:before {\n    content: \"\";\n    border-radius: 50%;\n    opacity: 2;\n    z-index: -1;\n    position: absolute;\n    width: 28px;\n    height: 28px;\n  }\n\n  svg {\n    padding: 8px;\n  }\n\n  .lanpopup {\n    border-radius: 3px;\n    background: var(--true-black-800, #252526);\n    display: inline-flex;\n    padding: 4px 8px 4px 8px;\n    align-items: center;\n    color: #fff;\n    font-family: \"intermedium\";\n    font-size: 10px;\n    line-height: 16px;\n    text-decoration-line: underline;\n    white-space: nowrap;\n    position: absolute;\n    right: 0;\n    top: 36px;\n    display: none;\n\n    &:before {\n      display: block;\n      position: absolute;\n      top: -12px;\n      height: 2px;\n      content: \"\";\n      border-right: solid 7px transparent;\n      border-left: solid 7px transparent;\n      border-bottom: solid 10px #252526;\n      right: 7px;\n    }\n  }\n\n  &:hover {\n    .lanpopup {\n      display: block;\n    }\n  }\n}\n\n.mics.activates {\n  background: #D2D3D4;\n  cursor: pointer;\n\n  &:before {\n    background: #d2d3d475;\n    animation: bounce 0.95s ease-in-out infinite 0.7s;\n    z-index: 9;\n  }\n}\n\n\n\n\n@keyframes bounce {\n  0% {\n    transform: scale(1);\n  }\n\n  ;\n\n  25% {\n    transform: scale(1.4);\n  }\n\n  75% {\n    transform: scale(1);\n  }\n\n  100% {\n    transform: scale(1.3);\n  }\n}\n\n\n.reactInputPh:hover .flag-dropdown,\n.reactInputPh:hover .formInputHeight,\n.reactInputPh .country-list .search:hover {\n  border-color: var(--widgetActionMessageColor) !important;\n}\n\n.chatpreviewleftview {\n  flex-direction: row-reverse;\n  gap: 20px;\n\n  .welcomemessage {\n    &::after {\n      right: unset;\n      left: -17px;\n      transform: rotate(270deg);\n    }\n\n    &::before {\n      right: unset;\n      left: -15px;\n      transform: rotate(270deg);\n    }\n\n    img {\n      right: -11px;\n      left: unset;\n    }\n  }\n}\n\n\n.leftagentchat {\n  p {\n    ul {\n      flex-direction: column;\n\n      li {\n        list-style: disc;\n      }\n    }\n\n    ol {\n      flex-direction: column;\n\n      li {\n        list-style: num;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
